export const legalEntityDataQa = {
  contactInformationRadio: 'WALLET_LEGAL_ENTITY_WALLET_CONTACT_INFORMATION_RADIO',
  emailTitle: 'WALLET_LEGAL_ENTITY_WALLET_EMAIL_TITLE',
  emailInput: 'WALLET_LEGAL_ENTITY_WALLET_EMAIL_INPUT',
  mobileNumberTitle: 'WALLET_LEGAL_ENTITY_WALLET_MOBILE_NUMBER_TITLE',
  mobileNumberInput: 'WALLET_LEGAL_ENTITY_WALLET_MOBILE_NUMBER_INPUT',
  phoneNumberTitle: 'WALLET_LEGAL_ENTITY_WALLET_PHONE_NUMBER_TITLE',
  phoneNumberInput: 'WALLET_LEGAL_ENTITY_WALLET_PHONE_NUMBER_INPUT',
  countryOfResidenceTitle: 'WALLET_LEGAL_ENTITY_WALLET_COUNTRY_OF_RESIDENCE_TITLE',
  countryOfResidenceInput: 'WALLET_LEGAL_ENTITY_WALLET_COUNTRY_OF_RESIDENCE_INPUT',
  addressTitle: 'WALLET_LEGAL_ENTITY_WALLET_ADDRESS_TITLE',
  addressInput: 'WALLET_LEGAL_ENTITY_WALLET_ADDRESS_INPUT',
  postalCodeTitle: 'WALLET_LEGAL_ENTITY_WALLET_POSTAL_CODE_TITLE',
  postalCodeInput: 'WALLET_LEGAL_ENTITY_WALLET_POSTAL_CODE_INPUT',
  cityTitle: 'WALLET_LEGAL_ENTITY_WALLET_CITY_TITLE',
  cityInput: 'WALLET_LEGAL_ENTITY_WALLET_CITY_INPUT',
  confirmPasswordTitle: 'WALLET_LEGAL_ENTITY_WALLET_CONFIRM_WITH_YOUR_PASSWORD_TITLE',
  confirmPasswordInput: 'WALLET_LEGAL_ENTITY_WALLET_CONFIRM_WITH_YOUR_PASSWORD_INPUT',
  confirmWithYourPasswordOeil: 'WALLET_LEGAL_ENTITY_WALLET_CONFIRM_WITH_YOUR_PASSWORD_OEIL',
  passwordEye: 'WALLET_LEGAL_ENTITY_WALLET_CONFIRM_WITH_YOUR_PASSWORD_OEIL',
  addWalletBtn: 'WALLET_LEGAL_ENTITY_WALLET_ADD_WALLET_BTN',
  walletIdTitle: 'WALLET_LEGAL_ENTITY_WALLET_WALLET_ID_TITLE',
  walletIdInput: 'WALLET_LEGAL_ENTITY_WALLET_WALLET_ID_INPUT',
  walletTypeTitle: 'WALLET_LEGAL_ENTITY_WALLET_WALLET_TYPE_TITLE',
  walletTitle: 'WALLET_LEGAL_ENTITY_WALLET_WALLET_TITLE',
  technicalWalletCheckbox: 'WALLET_LEGAL_ENTITY_WALLET_TECHNICAL_WALLET_CHECKBOX',
  onetimeCustomerCheckbox: 'WALLET_LEGAL_ENTITY_WALLET_ONETIME_CUSTOMER_CHECKBOX',
  collectingWalletCheckbox: 'WALLET_LEGAL_ENTITY_WALLET_COLLECTING_WALLET_CHECKBOX',
  cancelButton: 'WALLET_LEGAL_ENTITY_WALLET_CANCEL_BTN',
  continueButton: 'WALLET_LEGAL_ENTITY_WALLET_CONTINUE_BTN',
  saveButton: 'WALLET_LEGAL_ENTITY_WALLET_SAVE_BTN',
  backButton: 'WALLET_ADD_LEGAL_ENTITY_WALLET_BACK_BTN',
  popup: 'WALLET_ADD_LEGAL_ENTITY_WALLET_POPUP',
  payerRadio: 'WALLET_ADD_LEGAL_ENTITY_WALLET_PAYER_RADIO',
  beneficialRadio: 'WALLET_ADD_LEGAL_ENTITY_WALLET_BENEFICIAL_RADIO',
  yesCheckBox: 'WALLET_ADD_LEGAL_ENTITY_WALLET_BENEFICIAL_OWNER_YES_CHECKBOX',
  noCheckBox: 'WALLET_ADD_LEGAL_ENTITY_WALLET_BENEFICIAL_OWNER_NO_CHECKBOX'
};

export const walletListPageDataQa = {
  page: 'WALLET_LIST_PAGE',
  createIndividual: 'WALLET_LIST_CREATE_INDIVIDUAL',
  createLegalEntity: 'WALLET_LIST_CREATE_LEGAL_ENTITY',
  searchBar: 'WALLET_LIST_CREATE_SEARCH_BAR',
  refreshBtn: 'WALLET_LIST_CREATE_REFRESH_BTN',
  exportBtn: 'WALLET_LIST_CREATE_EXPORT_BTN',
  defaultDataBtn: 'WALLET_LIST_CREATE_RESET_DEFAULT_DATA_BTN',
  columnChooserBtn: 'WALLET_LIST_CREATE_COLUMN_CHOOSER_BTN'
};

export const individualDataQa = {
  contactInformationRadio: 'WALLET_ADD_INDIVIDUAL_WALLET_CONTACT_INFORMATION_RADIO',
  contactAddress: 'WALLET_ADD_INDIVIDUAL_WALLET_CONTACT_ADDRESS',
  emailTitle: 'WALLET_ADD_INDIVIDUAL_WALLET_EMAIL_TITLE',
  emailInput: 'WALLET_ADD_INDIVIDUAL_WALLET_EMAIL_INPUT',
  mobileNumberTitle: 'WALLET_ADD_INDIVIDUAL_WALLET_MOBILE_NUMBER_TITLE',
  mobileNumberInput: 'WALLET_ADD_INDIVIDUAL_WALLET_MOBILE_NUMBER_INPUT',
  phoneNumberTitle: 'WALLET_ADD_INDIVIDUAL_WALLET_PHONE_NUMBER_TITLE',
  phoneNumberInput: 'WALLET_ADD_INDIVIDUAL_WALLET_PHONE_NUMBER_INPUT',
  countryOfResidenceTitle: 'WALLET_ADD_INDIVIDUAL_WALLET_COUNTRY_OF_RESIDENCE_TITLE',
  countryOfResidenceInput: 'WALLET_ADD_INDIVIDUAL_WALLET_COUNTRY_OF_RESIDENCE_INPUT',
  addressTitle: 'WALLET_ADD_INDIVIDUAL_WALLET_ADDRESS_TITLE',
  addressInput: 'WALLET_ADD_INDIVIDUAL_WALLET_ADDRESS_INPUT',
  postalCodeTitle: 'WALLET_ADD_INDIVIDUAL_WALLET_POSTAL_CODE_TITLE',
  postalCodeInput: 'WALLET_ADD_INDIVIDUAL_WALLET_POSTAL_CODE_INPUT',
  cityTitle: 'WALLET_ADD_INDIVIDUAL_WALLET_CITY_TITLE',
  cityInput: 'WALLET_ADD_INDIVIDUAL_WALLET_CITY_INPUT',
  confirmPasswordTitle: 'WALLET_ADD_INDIVIDUAL_WALLET_CONFIRM_WITH_YOUR_PASSWORD_TITLE',
  confirmPasswordInput: 'WALLET_ADD_INDIVIDUAL_WALLET_CONFIRM_WITH_YOUR_PASSWORD_INPUT',
  confirmWithYourPasswordOeil:
    'WALLET_ADD_INDIVIDUAL_WALLET_WALLET_CONFIRM_WITH_YOUR_PASSWORD_OEIL',
  passwordEye: 'WALLET_ADD_INDIVIDUAL_WALLET_CONFIRM_WITH_YOUR_PASSWORD_OEIL',
  addWalletBtn: 'WALLET_ADD_INDIVIDUAL_WALLET_ADD_WALLET_BTN',
  walletIdTitle: 'WALLET_ADD_INDIVIDUAL_WALLET_WALLET_ID_TITLE',
  walletIdInput: 'WALLET_ADD_INDIVIDUAL_WALLET_WALLET_ID_INPUT',
  walletTypeTitle: 'WALLET_ADD_INDIVIDUAL_WALLET_WALLET_TYPE_TITLE',
  walletTitle: 'WALLET_ADD_INDIVIDUAL_WALLET_TITLE',
  technicalWalletCheckbox: 'WALLET_ADD_INDIVIDUAL_WALLET_TECHNICAL_WALLET_CHECKBOX',
  onetimeCustomerCheckbox: 'WALLET_ADD_INDIVIDUAL_WALLET_ONETIME_CUSTOMER_CHECKBOX',
  collectingWalletCheckbox: 'WALLET_ADD_INDIVIDUAL_WALLET_COLLECTING_WALLET_CHECKBOX',
  cancelButton: 'WALLET_ADD_INDIVIDUAL_WALLET_CANCEL_BTN',
  continueButton: 'WALLET_ADD_INDIVIDUAL_WALLET_CONTINUE_BTN',
  saveButton: 'WALLET_ADD_INDIVIDUAL_WALLET_SAVE_BTN',
  backButton: 'WALLET_ADD_INDIVIDUAL_WALLET_BACK_BTN',
  popup: 'WALLET_ADD_INDIVIDUAL_WALLET_POPUP',
  payerRadio: 'WALLET_ADD_INDIVIDUAL_WALLET_PAYER_RADIO',
  beneficialRadio: 'WALLET_ADD_INDIVIDUAL_WALLET_BENEFICIAL_RADIO',
  yesCheckBox: 'WALLET_ADD_INDIVIDUAL_WALLET_BENEFICIAL_OWNER_YES_CHECKBOX',
  noCheckBox: 'WALLET_ADD_INDIVIDUAL_WALLET_BENEFICIAL_OWNER_NO_CHECKBOX'
};

export const blockWalletDataQa = {
  popup: 'BLOCK_WALLET_POPUP',
  redNotification: 'BLOCK_WALLET_RED_NOTIFICATION',
  commentTitle: 'BLOCK_WALLET_COMMENT_TITLE',
  commentInput: 'BLOCK_WALLET_COMMENT_INPUT',
  confirmWithYourPasswordTitle: 'BLOCK_WALLET_CONFIRM_WITH_YOUR_PASSWORD_TITLE',
  confirmWithYourPasswordInput: 'BLOCK_WALLET_CONFIRM_WITH_YOUR_PASSWORD_INPUT',
  confirmWithYourPasswordOeil: 'BLOCK_WALLET_CONFIRM_WITH_YOUR_PASSWORD_OEIL',
  cancelBtn: 'BLOCK_WALLET_CANCEL_BTN',
  submit: 'BLOCK_WALLET_BLOCK_BTN'
};

export const unblockWalletDataQa = {
  popup: 'UNBLOCK_WALLET_POPUP',
  redNotification: 'UNBLOCK_WALLET_RED_NOTIFICATION',
  commentTitle: 'UNBLOCK_WALLET_COMMENT_TITLE',
  commentInput: 'UNBLOCK_WALLET_COMMENT_INPUT',
  confirmWithYourPasswordTitle: 'UNBLOCK_WALLET_CONFIRM_WITH_YOUR_PASSWORD_TITLE',
  confirmWithYourPasswordInput: 'UNBLOCK_WALLET_CONFIRM_WITH_YOUR_PASSWORD_INPUT',
  confirmWithYourPasswordOeil: 'UNBLOCK_WALLET_CONFIRM_WITH_YOUR_PASSWORD_OEIL',
  cancelBtn: 'UNBLOCK_WALLET_CANCEL_BTN',
  submit: 'UNBLOCK_WALLET_UNBLOCK_BTN'
};

export const walletOverviewDataQa = {
  page: 'WALLET_OVERVIEW_PAGE',
  walletBtnContent: 'WALLETS_OVERVIEW_ACCOUNT_BTN_CONTENT',
  onglet: 'WALLET_OVERVIEW_ONGLET',
  thresholdsTitle: 'WALLET_OVERVIEW_THRESHOLDS_TITLE',
  thresholdsDetailsBtn: 'WALLET_OVERVIEW_THRESHOLDS_DETAILS_BTN',
  thresholds24HoursBtn: 'WALLET_OVERVIEW_THRESHOLDS_24HOURS_BTN',
  thresholdsMonthlyBtn: 'WALLET_OVERVIEW_THRESHOLDS_MONTHLY_BTN',
  thresholdsYearlyBtn: 'WALLET_OVERVIEW_THRESHOLDS_YEARLY_BTN',
  thresholdsLastTransactionTitle: 'WALLET_OVERVIEW_THRESHOLDS_LAST_TRANSACTION_TITLE',
  thresholdsLastTransactionBtn: 'WALLET_OVERVIEW_THRESHOLDS_LAST_TRANSACTION_BTN'
};

export const walletDocumentsDataQa = {
  page: 'WALLET_DOCUMENTS_PAGE',
  onglet: 'WALLET_DOCUMENTS_ONGLET',
  addDocumentBtn: 'WALLET_DOCUMENTS_ADD_DOCUMENT_BTN',
  documentsTitle: 'WALLET_DOCUMENTS_DOCUMENTS_TITLE',
  idListBtn: 'WALLET_DOCUMENTS_ID_LIST_BTN',
  proofOfAddressListBtn: 'WALLET_DOCUMENTS_PROF_OF_ADDRESS_LIST_BTN',
  detailsTitle: 'WALLET_DOCUMENTS_DOCUMENT_DETAILS_TITLE',
  editBtn: 'WALLET_DOCUMENTS_DOCUMENT_DETAILS_REPLACE_DOCUMENT',
  proofOfAddressTitle: 'WALLET_DOCUMENTS_DOCUMENT_DETAILS_PROF_OF_ADDRESS_TITLE',
  proofOfAddressBlueMsg: 'WALLET_DOCUMENTS_DOCUMENT_DETAILS_PROF_OF_ADDRESS_BLUE_MSG',
  proofOfAddressImg: 'WALLET_DOCUMENTS_DOCUMENT_DETAILS_PROF_OF_ADDRESS_IMG',
  proofOfAddressDownloadImg: 'WALLET_DOCUMENTS_DOCUMENT_DETAILS_PROF_OF_ADDRESS_DOWNLOAD_IMG',
  proofOfAddressOpenInNewWindowImg:
    'WALLET_DOCUMENTS_DOCUMENT_DETAILS_PROF_OF_ADDRESS_OPEN_IN_NEW_WINDOW_IMG',
  proofOfAddressPreviewImg: 'WALLET_DOCUMENTS_DOCUMENT_DETAILS_PROF_OF_ADDRESS_PREVIEW_IMG',
  replaceDocument: 'WALLET_DOCUMENTS_DOCUMENT_DETAILS_REPLACE_DOCUMENT',
  idYellowMsg: 'WALLET_DOCUMENTS_DOCUMENT_DETAILS_ID_YELLOW_MSG',
  other: 'WALLET_DOCUMENTS_DOCUMENT_DETAILS_OTHER',
  bank_account_statement: 'WALLET_DOCUMENTS_DOCUMENTS_BANK_ACCOUNT_STATEMENT',
  eu_passport: 'WALLET_DOCUMENTS_DOCUMENTS_EU_PASSPORT',
  non_eu_passport: 'WALLET_DOCUMENTS_DOCUMENTS_NON_EU_PASSPORT',
  residence_permit: 'WALLET_DOCUMENTS_DOCUMENTS_RESIDENCE_PERMIT',
  company_registration: 'WALLET_DOCUMENTS_DOCUMENTS_COMPANY_REGISTRATION',
  drivers_license: 'WALLET_DOCUMENTS_DOCUMENTS_DRIVERS_LICENSE',
  articles_of_association: 'WALLET_DOCUMENTS_DOCUMENTS_ARTICLES_OF_ASSOCIATION',
  selfie: 'WALLET_DOCUMENTS_DOCUMENTS_SELFIE',
  sdd_mandate: 'WALLET_DOCUMENTS_DOCUMENTS_SDD_MANDATE'
};

export const transactionRequestsDataQa = {
  page: 'TRANSACTION_REQUESTS_PAGE',
  grid: 'TRANSACTION_REQUESTS_GRID',
  statusRequestedBtn: 'TRANSACTION_REQUESTS_STATUS_REQUESTED_BTN',
  statusValidatedBtn: 'TRANSACTION_REQUESTS_STATUS_VALIDATED_BTN',
  statusCancelledBtn: 'TRANSACTION_REQUESTS_STATUS_CANCELLED_BTN',
  statusRejectedBtn: 'TRANSACTION_REQUESTS_STATUS_REJECTED_BTN'
};

const walletDocumentDetails: { [key: number]: string } = {
  0: 'ID',
  1: 'PROF_OF_ADDRESS',
  2: 'BANK_ACCOUNT_STATEMENT',
  3: 'EU_PASSPORT',
  4: 'NON_EU_PASSPORT',
  5: 'RESIDENCE_PERMIT',
  7: 'COMPANY_REGISTRATION',
  11: 'DRIVERS_LICENSE',
  12: 'ARTICLES_OF_ASSOCIATION',
  13: 'SELFIE',
  21: 'SDD_MANDATE'
};

export const walletDocumentDetailsDataQa = (groupId: number) => {
  const documentGroup = walletDocumentDetails[groupId] || 'OTHER';
  return {
    title: `WALLET_DOCUMENTS_DOCUMENT_DETAILS_${documentGroup}_TITLE`,
    blueMsg: `WALLET_DOCUMENTS_DOCUMENT_DETAILS_${documentGroup}_BLUE_MSG`,
    yellowMsg: `WALLET_DOCUMENTS_DOCUMENT_DETAILS_${documentGroup}_YELLOW_MSG`,
    redMsg: `WALLET_DOCUMENTS_DOCUMENT_DETAILS_${documentGroup}_RED_MSG`,
    comment: `WALLET_DOCUMENTS_DOCUMENT_DETAILS_${documentGroup}_COMMENT_TXT`,
    img: `WALLET_DOCUMENTS_DOCUMENT_DETAILS_${documentGroup}_IMG`,
    downloadImg: `WALLET_DOCUMENTS_DOCUMENT_DETAILS_${documentGroup}_DOWNLOAD_IMG`,
    openInNewWindowImg: `WALLET_DOCUMENTS_DOCUMENT_DETAILS_${documentGroup}_OPEN_IN_NEW_WINDOW_IMG`,
    previewImg: `WALLET_DOCUMENTS_DOCUMENT_DETAILS_${documentGroup}_PREVIEW`
  };
};

export const getDataQaByTheme = (id: number, value: string) => {
  const dataQa = walletDocumentDetailsDataQa(id);
  switch (value) {
    case 'warning':
      return dataQa?.yellowMsg;
    case 'success':
      return dataQa?.blueMsg;
    case 'danger':
      return dataQa?.redMsg;
    default:
      return '';
  }
};

export const walletTransactionDataQa = {
  title: 'WALLET_TRANSACTION_TITLE',
  onglet: 'WALLET_TRANSACTION_ONGLET',
  sendPaymentToAnotherWalletBtn: 'WALLET_TRANSACTION_SEND_PAYMENT_TO_ANOTHER_ACCOUNT_BTN',
  dateSelector: 'WALLET_TRANSACTION_DATE_SELECTOR',
  searchBar: 'WALLET_TRANSACTION_SEARCH_BAR',
  refreshBtn: 'WALLET_TRANSACTION_REFRESH_BTN',
  exportBtn: 'WALLET_TRANSACTION_EXPORT_BTN',
  Btn: 'WALLET_TRANSACTION_EXPORT_BTN',
  defaultDataBtn: 'WALLET_TRANSACTION_DEFAULT_DATA_BTN',
  columnChooserBtn: 'WALLET_TRANSACTION_COLUMN_CHOOSER_BTN',
  id: 'WALLET_TRANSACTION_TRANSACTION_ID',
  simulateAMoney: 'WALLET_TRANSACTION_SIMULATE_MONEY_OUT'
};

export const sendPaymentDataQa = {
  popup: 'SEND_PAYMENT_TO_ANOTHER_WALLET_POPUP',
  title: 'SEND_PAYMENT_TO_ANOTHER_WALLET_TITLE',
  senderTitle: 'SEND_PAYMENT_TO_ANOTHER_WALLET_SENDER_TITLE',
  senderInput: 'SEND_PAYMENT_TO_ANOTHER_WALLET_SENDER_INPUT',
  receiverTitle: 'SEND_PAYMENT_TO_ANOTHER_WALLET_RECEIVER_TITLE',
  receiverInput: 'SEND_PAYMENT_TO_ANOTHER_WALLET_RECEIVER_INPUT',
  amountTitle: 'SEND_PAYMENT_TO_ANOTHER_WALLET_AMOUNT_TITLE',
  amountInput: 'SEND_PAYMENT_TO_ANOTHER_WALLET_AMOUNT_INPUT',
  parentTransactionTitle: 'SEND_PAYMENT_TO_ANOTHER_WALLET_PARENT_TRANSACTION_TITLE',
  parentTransactionInput: 'SEND_PAYMENT_TO_ANOTHER_WALLET_PARENT_TRANSACTION_INPUT',
  commentTitle: 'SEND_PAYMENT_TO_ANOTHER_WALLET_COMMENT_TITLE',
  commentInput: 'SEND_PAYMENT_TO_ANOTHER_WALLET_COMMENT_INPUT',
  confirmWithYourPasswordTitle: 'SEND_PAYMENT_TO_ANOTHER_WALLET_CONFIRM_WITH_YOUR_PASSWORD_TITLE',
  confirmWithYourPasswordInput: 'SEND_PAYMENT_TO_ANOTHER_WALLET_CONFIRM_WITH_YOUR_PASSWORD_INPUT',
  confirmWithYourPasswordOiel: 'SEND_PAYMENT_TO_ANOTHER_WALLET_CONFIRM_WITH_YOUR_PASSWORD_OIEL',
  cancelBtn: 'SEND_PAYMENT_TO_ANOTHER_WALLET_CANCEL_BTN',
  continueBtn: 'SEND_PAYMENT_TO_ANOTHER_WALLET_CONTINUE_BTN',
  backBtn: 'SEND_PAYMENT_TO_ANOTHER_WALLET_BACK_BTN',
  closeIcon: 'SEND_PAYMENT_TO_ANOTHER_WALLET_CLOSE_ICON'
};

export const walletBankDataQa = {
  page: 'WALLET_BANK_WALLET_PAGE',
  onglet: 'WALLET_BANK_WALLET_ONGLET',
  title: 'WALLET_BANK_WALLET_TITLE',
  doAWireTransferBtn: 'WALLET_BANK_WALLET_DO_A_WIRE_TRANSFER_BTN',
  addBankWallet: 'WALLET_BANK_WALLET_ADD_BANK_WALLET',
  searchBar: 'WALLET_BANK_WALLET_SEARCH_BAR',
  refreshBtn: 'WALLET_BANK_WALLET_REFRESH_BTN',
  exportBtn: 'WALLET_BANK_WALLET_EXPORT_BTN',
  defaultDataBtn: 'WALLET_BANK_WALLET_DEFAULT_DATA_BTN',
  columnChooserBtn: 'WALLET_BANK_WALLET_COLUMN_CHOOSER_BTN',
  actionDoAWireTransferBtn: 'WALLET_TRANSACTION_ACTION_DO_A_WIRE_TRANSFER_BTN',
  actionCancelWireTransferBtn: 'WALLET_BANK_WALLET_ACTION_CANCEL_WIRE_TRANSFER_BTN',
  editStatus: 'WALLET_BANK_WALLET_ACTION_EDIT_STATUS_BTN',
  idFiltreBtn: 'WALLET_BANK_WALLET_ID_FILTRE_BTN', // I couldn't find a way to customize the filter button of this column to add the data-qa attribute
  statusFiltreBtn: 'WALLET_BANK_WALLET_STATUS_FILTRE_BTN', // I couldn't find a way to customize the filter button of this column to add the data-qa attribute
  walletTypeFiltreBtn: 'WALLET_BANK_WALLET_ACCOUNTTYPE_FILTRE_BTN', // I couldn't find a way to customize the filter button of this column to add the data-qa attribute
  transactionBankCountryFiltreBtn: 'WALLET_TRANSACTION_BANK_COUNTRY_FILTRE_BTN' // I couldn't find a way to customize the filter button of this column to add the data-qa attribute
};

export const wireTransferPopupDataQa = {
  popupTitle: 'DO_A_WIRE_TRANSFER_POPUP_TITLE',
  bankAccountTitle: 'DO_A_WIRE_TRANSFER_POPUP_BANK_ACCOUNT_TITLE',
  bankAccountInput: 'DO_A_WIRE_TRANSFER_POPUP_BANK_ACCOUNT_INPUT',
  amountTitle: 'DO_A_WIRE_TRANSFER_POPUP_AMOUNT_TITLE',
  amountInput: 'DO_A_WIRE_TRANSFER_POPUP_AMOUNT_INPUT',
  commentTitle: 'DO_A_WIRE_TRANSFER_POPUP_COMMENT_TITLE',
  commentInput: 'DO_A_WIRE_TRANSFER_POPUP_COMMENT_INPUT',
  confirmWithYourPasswordTitle: 'DO_A_WIRE_TRANSFER_POPUP_CONFIRM_WITH_YOUR_PASSWORD_TITLE',
  confirmWithYourPasswordInput: 'DO_A_WIRE_TRANSFER_POPUP_CONFIRM_WITH_YOUR_PASSWORD_INPUT',
  confirmWithYourPasswordOeil: 'DO_A_WIRE_TRANSFER_POPUP_CONFIRM_WITH_YOUR_PASSWORD_OEIL',
  cancelBtn: 'DO_A_WIRE_TRANSFER_POPUP_CANCEL_BTN',
  submitBtn: 'DO_A_WIRE_TRANSFER_POPUP_SUBMIT_BTN',
  closeIcon: 'DO_A_WIRE_TRANSFER_POPUP_CLOSE_ICON'
};

export const disableBankAccountDataQa = {
  popup: 'DISABLE_BANK_ACCOUNT_POPUP',
  title: 'DISABLE_BANK_ACCOUNT_TITLE',
  yellowMsg: 'DISABLE BANK ACCOUNT YELLOW_MSG',
  ibanDetails: 'DISABLE BANK ACCOUNT IBAN_DETAILS',
  confirmWithYourPasswordTitle: 'DISABLE_BANK_ACCOUNT_CONFIRM WITH YOUR PASSWORD_TITLE',
  confirmWithYourPasswordInput: 'DISABLE_BANK_ACCOUNT_CONFIRM WITH YOUR_PASSWORD INPUT',
  confirmWithYourPasswordOiel: 'DISABLE_BANK_ACCOUNT_CONFIRM WITH YOUR PASSWORD_OIEL',
  cancelBtn: 'DISABLE_BANK_ACCOUNT_CANCEL_BTN',
  disabledBtn: 'DISABLE_BANK_ACCOUNT_DISABLED_BTN',
  closeIcon: 'DISABLE_BANK_ACCOUNT_CLOSE_ICON'
};

export const addBankAccountDataQa = {
  popup: 'ADD_BANK_ACCOUNT_POPUP',
  title: 'ADD_BANK_ACCOUNT_TITLE',
  bankCountryRadioSection: 'ADD BANK ACCOUNT BANK COUNTRY_RADIO_SECTION',
  bankAccountRadioSection: 'ADD_BANK_ACCOUNT_BANK_ACCOUNT_RADIO_SECTION',
  confirmationRadioSection: 'ADD_BANK_ACCOUNT_CONFIRMATION_RADIO_SECTION',
  countryTitle: 'ADD_BANK_ACCOUNT_BANK_COUNTRY_TITLE',
  holderCountryTitle: 'ADD_BANK_ACCOUNT_BANK_COUNTRY_HOLDER_TITLE',
  holderCountryInput: 'ADD_BANK_ACCOUNT_BANK_COUNTRY_HOLDER_INPUT',
  ibanTitle: 'ADD_BANK_ACCOUNT_BANK_COUNTRY_IBAN_TITLE',
  ibanInput: 'ADD_BANK_ACCOUNT_BANK_COUNTRY_IBAN_INPUT',
  typeIbanBtn: 'ADD_BANK_ACCOUNT_BANK_TYPE_IBAN_BTN',
  type: 'ADD_BANK_ACCOUNT_BANK_TYPE_TEXT',
  accountNumberBtn: 'ADD_BANK_ACCOUNT_BANK_TYPE_ACCOUNT_NUMBER_BTN',
  bankIntermediaryRadioSection: 'ADD_BANK_ACCOUNT_BANK_INTERMEDIARY_TITLE',
  bankCountryInputSelector: 'ADD_BANK_ACCOUNT_BANK_COUNTRY_INPUT_SELECTOR',
  bankCountryTitleSelector: 'ADD_BANK_ACCOUNT_BANK_COUNTRY_TITLE_SELECTOR',
  bankCountryTitle: 'ADD_BANK_COUNTRY_TITLE',
  cancelBtn: 'ADD_BANK_ACCOUNT_CANCEL_BTN',
  continueBtn: 'ADD_BANK_ACCOUNT_CONTINUE_BTN',
  addBtn: 'ADD_BANK_ACCOUNT_ADD_BTN',
  backBtn: 'ADD_BANK_ACCOUNT_BACK_BTN',
  closeIcon: 'ADD_BANK_ACCOUNT_CLOSE ICON',
  holderAccountTitle: 'ADD_BANK_ACCOUNT_BANK_ACCOUNT_HOLDER_TITLE',
  holderAccountInput: 'ADD_BANK_ACCOUNT_BANK_ACCOUNT_HOLDER_INPUT',
  bankAccountNumberTitle: 'ADD_BANK_ACCOUNT_BANK_ACOUNT_NUMBER_TITLE',
  bankAccountNumberInput: 'ADD_BANK_ACCOUNT_BANK_ACOUNT_NUMBER_INPUT',
  bankBranchSortCodeTitle: 'ADD_BANK_ACCOUNT_BANK_BRANCH_SORT_CODE_TITLE',
  bankBranchSortCodeInput: 'ADD_BANK_ACCOUNT_BANK_BRANCH_SORT_CODE_INPUT',
  bankBicSwiftTitle: 'ADD_BANK_ACCOUNT_BANK_BIC_SWIFT_TITLE',
  bankBicSwiftInput: 'ADD_BANK_ACCOUNT_BANK_BIC_SWIFT_INPUT',
  enterIntermediaryBankTitle: 'ADD_BANK_ACCOUNT_BANK_ENTER_INTERMEDIARY_BANK_TITLE',
  enterIntermediaryBankYesBtn: 'ADD_BANK_ACCOUNT_BANK_ENTER_INTERMEDIARY_BANK_YES_BTN',
  enterIntermediaryBankNoBtn: 'ADD_BANK_ACCOUNT_BANK_ENTER_INTERMEDIARY_BANK_NO_BTN',
  intermediaryBankTitle: 'ADD_BANK_ACCOUNT_INTERMEDIARY_BANK_TITLE',
  bankIntermediaryBankSection: 'ADD_BANK_ACCOUNT_BANK_INTERMEDIARY_BANK_SECTION',
  intermediaryBankCountryTitle: 'ADD_BANK_ACCOUNT_INTERMEDIARY_BANK_COUNTRY_TITLE',
  intermediaryBankCountryInputSelector: 'ADD_BANK_ACCOUNT_INTERMEDIARY_BANK_COUNTRY_INPUT_SELECTOR',
  intermediaryBicSwiftTitle: 'ADD_BANK_ACCOUNT_INTERMEDIARY_BIC_SWIFT_TITLE',
  intermediaryBicSwiftInput: 'ADD_BANK_ACCOUNT_INTERMEDIARY_BIC_SWIFT_INPUT',
  intermediaryBankNameTitle: 'ADD_BANK_ACCOUNT_INTERMEDIARY_BANK_NAME_TITLE',
  intermediaryBankNameInput: 'ADD_BANK_ACCOUNT_INTERMEDIARY_BANK_NAME_INPUT',
  bankNameTitle: 'ADD_BANK_ACCOUNT_BANK_NAME_TITLE',
  bankNameInput: 'ADD_BANK_ACCOUNT_BANK_NAME_INPUT',
  bankAddressTitle: 'ADD_BANK_ACCOUNT_BANK_ADDRESS_TITLE',
  bankAddressInput: 'ADD_BANK_ACCOUNT_BANK_ADDRESS_INPUT',
  bankPostalCodeTitle: 'ADD_BANK_ACCOUNT_BANK_POSTAL_CODE_TITLE',
  bankPostalCodeInput: 'ADD_BANK_ACCOUNT_BANK_POSTAL_CODE_INPUT',
  bankCityTitle: 'ADD_BANK_ACCOUNT_BANK_CITY_TITLE',
  bankCityInput: 'ADD_BANK_ACCOUNT_BANK_CITY_INPUT',
  confirmationTitle: 'ADD_BANK_ACCOUNT_CONFIRMATION_TITLE',
  confirmationCommentTitle: 'ADD_BANK_ACCOUNT_CONFIRMATION_COMMENT_TITLE',
  confirmationCommentInput: 'ADD_BANK_ACCOUNT_CONFIRMATION_COMMENT_INPUT',
  confirmWithYourPasswordTitle: 'ADD_BANK_ACCOUNT_CONFIRMATION_CONFIRM_WITH_YOUR_PASSWORD_TITLE',
  confirmWithYourPasswordInput: 'ADD_BANK_ACCOUNT_CONFIRMATION_CONFIRM_WITH_YOUR_PASSWORD_INPUT',
  confirmWithYourPasswordOiel: 'ADD_BANK_ACCOUNT_CONFIRMATION_CONFIRM_WITH_YOUR_PASSWORD_OIEL',
  disableConfirmWithYourPasswordOiel: 'DISABLE_BANK_ACCOUNT_CONFIRM_WITH_YOUR_PASSWORD_OIEL'
};

export const walletPaymentMethodsDataQa = {
  page: 'WALLET_PAYMENT_METHODS_PAGE',
  onglet: 'WALLET_PAYMENT_METHODS OGNLET',
  sddMandatesOnglet: 'WALLET_PAYMENT_METHODS_SDD_MANDATES_ONGLET',
  virtualIbansOnglet: 'WALLET_PAYMENT_METHODS_VIRTUAL_IBANS_ONGLET',
  savedCardsOnglet: 'WALLET_PAYMENT_METHODS_SAVED_CARDS_ONGLET',
  paymentFormsOnglet: 'WALLET_PAYMENT_METHODS_PAYMENT_FORMS_ONGLET',
  title: 'WALLET_PAYMENT_METHODS_TITLE'
};

export const virtualIbansDataQa = {
  title: 'WALLET_PAYMENT_METHODS_TITLE',
  btn: 'WALLET_PAYMENT_METHODS GENERATE VIRTUAL_IBAN_BTN',
  searchBar: 'WALLET_PAYMENT_METHODS_SEARCH_BAR',
  refreshBtn: 'WALLET_PAYMENT_METHODS_REFRESH_BTN',
  exportBtn: 'WALLET_PAYMENT_METHODS_EXPORT_BTN',
  defaultDataBtn: 'WALLET_PAYMENT_METHODS_DEFAULT_DATA_BTN',
  columnChooserBtn: 'WALLET_PAYMENT_METHODS_COLUMN_CHOOSER_BTN',
  actionCancelBtn: 'WALLET_PAYMENT_METHODS_ACTION_CANCEL_BTN',
  actionPdfDownloadBtn: 'WALLET_PAYMENT_METHODS_ACTION_PDF_DOWNLOAD_BTN'
};

export const generateVirtualIbanDataQa = {
  popup: 'GENERATE_VIRTUAL_IBAN_POPUP',
  title: 'GENERATE_VIRTUAL_IBAN_TITLE',
  ibanCountryTitle: 'GENERATE_VIRTUAL IBAN IBAN_COUNTRY_TITLE',
  ibanCountryInputSelector: 'GENERATE_VIRTUAL_IBAN_IBAN_COUNTRY_INPUT_SELECTOR',
  confirmWithYourPasswordTitle: 'GENERATE VIRTUAL IBAN_CONFIRM WITH YOUR_PASSWORD_TITLE',
  confirmWithYourPasswordInput: 'GENERATE_VIRTUAL IBAN_CONFIRM_WITH_YOUR_PASSWORD_INPUT',
  confirmWithYourPasswordOiel: 'GENERATE_VIRTUAL IBAN_CONFIRM_WITH_YOUR_PASSWORD_OIEL',
  cancelBtn: 'GENERATE VIRTUAL_IBAN_CANCEL_BTN',
  generateBtn: 'GENERATE_VIRTUAL IBAN_GENERATE_BTN',
  closeIcon: 'GENERATE VIRTUAL IBAN CLOSE_ICON',
  greenGeneratedMsg: 'GENERATE_VIRTUAL_IBAN_GREEN_GENERATED_MSG',
  yourVirtualIbanTitle: 'GENERATE VIRTUAL_IBAN_YOUR_VIRTUAL_IBAN_TITLE',
  yourVirtualIbanIbanTxt: 'GENERATE_VIRTUAL_IBAN_YOUR_VIRTUAL IBAN IBAN_TXT',
  yourVirtualIbanBicSwiftTxt: 'GENERATE_VIRTUAL_IBAN_YOUR_VIRTUAL_IBAN_BIC_SWIFT_TXT',
  yourVirtualIbanHolderTxt: 'GENERATE_VIRTUAL_IBAN_YOUR_VIRTUAL IBAN_HOLDER_TXT',
  yourVirtualIbanDomiciliationTxt: 'GENERATE_VIRTUAL_IBAN_YOUR_VIRTUAL_IBAN_DOMICILIATION_TXT',
  copyBtn: 'GENERATE_VIRTUAL IBAN_COPY_BTN',
  downloadBtn: 'GENERATE_VIRTUAL IBAN_DOWNLOAD_BTN'
};

export const walletSddMandatesDataQa = {
  page: 'WALLET_SDD_MANDATES_PAGE',
  title: 'WALLET_SDD_MANDATES_TITLE',
  btn: 'WALLET_SDD_MANDATES_ADD_SDD_MANDATES',
  searchBar: 'WALLET_SDD_MANDATES_SEARCH_BAR',
  refreshBtn: 'WALLET_SDD_MANDATES_REFRESH_BTN',
  exportBtn: 'WALLET_SDD_MANDATES_EXPORT_BTN',
  defaultDataBtn: 'WALLET_SDD_MANDATES_DEFAULT_DATA_BTN',
  columnChooserBtn: 'WALLET_SDD_MANDATES_COLUMN_CHOOSER_BTN',
  actionRequestDebitBtn: 'WALLET_SDD_MANDATES_ACTION_REQUEST_DEBIT_BTN',
  actionCancelDebitBtn: 'WALLET_SDD_MANDATES_ACTION_CANCEL_DEBIT_BTN',
  idFilterBtn: 'WALLET_SDD_MANDATES_ID_FILTRE_BTN',
  statusFilterBtn: 'WALLET_SDD_MANDATES_STATUS_FILTRE_BTN',
  walletTypeFilterBtn: 'WALLET_SDD_MANDATES_ACCOUNT_TYPE_FILTRE_BTN',
  bankCountryFilterBtn: 'WALLET_SDD_MANDATES_BANK_COUNTRY_FILTRE_BTN'
};

export const addSddMandatesDataQa = {
  popup: 'ADD_SDD_MANDATES_POPUP',
  mandateTitle: 'ADD_SDD_MANDATES_MANDATE_TITLE',
  mandateRadio: 'ADD_SDD_MANDATES_MANDATE_RADIO',
  additionalInformationRadio: 'ADD_SDD_MANDATES_ADDITIONAL_INFORMATION_RADIO',
  holderTitle: 'ADD_SDD_MANDATES_HOLDER_TITLE',
  holderInput: 'ADD_SDD_MANDATES_HOLDER_INPUT',
  ibanAccountNumberTitle: 'ADD_SDD_MANDATES_IBAN_ACCOUNT_NUMBER_TITLE',
  ibanAccountNumberInput: 'ADD_SDD_MANDATES_IBAN_ACCOUNT_NUMBER_INPUT',
  bicSwiftTitle: 'ADD_SDD_MANDATES_BIC_SWIFT_TITLE',
  bicSwiftInput: 'ADD_SDD_MANDATES_BIC_SWIFT_INPUT',
  umrTitle: 'ADD_SDD_MANDATES_UMR_TITLE',
  umrInput: 'ADD_SDD_MANDATES_UMR_INPUT',
  recuring: 'ADD_SDD_MANDATES_RECURING_CHECKBOX',
  b2b: 'ADD_SDD_MANDATES_B2B_CHECKBOX',
  continueBtn: 'ADD_SDD_MANDATES_CONTINUE_BTN',
  addBtn: 'ADD_SDD_MANDATES_ADD_BTN',
  backBtn: 'ADD_SDD_MANDATES_BACK_BTN',
  cancelBtn: 'ADD_SDD_MANDATES_CANCEL_BTN',
  closeIcon: 'ADD_SDD_MANDATES_CLOSE ICON'
};

export const sendPaymentBetweentWalletsDataQa = {
  popup: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP',
  title: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_TITLE',
  senderTitle: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_SENDER_TITLE',
  senderInput: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_SENDER_INPUT',
  senderCloseIcon: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_SENDER_CLOSE_ICON',
  receiverTitle: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_RECEIVER_TTLE',
  receiverInput: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_RECEIVER_INPUT',
  receiverCloseIcon: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_RECEIVER_CLOSE_ICON',
  amountTitle: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_AMOUNT_TITLE',
  amountInput: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_AMOUNT_INPUT',
  parentTransactionTitle: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_PARENT_TRANSACTION_TITLE',
  parentTransactionInput: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_PARENT_TRANSACTION_INPUT',
  parentTransactionCloseIcon: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_PARENT_TRANSACTION_CLOSE_ICON',
  amountEurTxt: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_AMOUNT_EUR_TXT',
  commentTitle: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_COMMENT_TITLE',
  commentInput: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_COMMENT_INPUT',
  confirmWithYourPasswordTitle:
    'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_CONFIRM_WITH_YOUR_PASSWORD_TITLE',
  confirmWithYourPasswordInput:
    'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_CONFIRM_WITH_YOUR_PASSWORD_INPUT',
  confirmWithYourPasswordOiel: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_CONFIRM_WITH_YOUR_PASSWORD_OIEL',
  cancelBtn: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_CANCEL_BTN',
  continueBtn: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_CONTINUE_BTN',
  closeIcon: 'SEND_PAYMENT_BETWEEN_WALLETS_POPUP_CLOSE_ICON'
};

export const transactionAllDataQa = {
  page: 'TRANSACTION_ALL_PAGE',
  title: 'TRANSACTION_ALL_TITLE',
  sendPaymentToAnotherWalletBtn: 'TRANSACTION_ALL_SEND_PAYMENT_TO_ANOTHER_ACCOUNT_BTN',
  simulateMoneyInBtn: 'TRANSACTION_ALL_SIMULATE_MONEY_IN_BTN',
  dateSelector: 'TRANSACTION_ALL_DATE_SELECTOR',
  searchBar: 'TRANSACTION_ALL_SEARCH_BAR',
  refreshBtn: 'TRANSACTION_ALL_REFRESH_BTN',
  exportBtn: 'TRANSACTION_ALL_EXPORT_BTN',
  defaultDataBtn: 'TRANSACTION_ALL_DEFAULT_DATA_BTN',
  columnChooserBtn: 'TRANSACTION_ALL_COLUMN_CHOOSER_BTN',
  id: 'TRANSACTION_ALL_TRANSACTION_ID',
  idFilterBtn: 'TRANSACTION_ALL_ID_FILTRE_BTN',
  typeFilterBtn: 'TRANSACTION_ALL_TYPE_FILTRE_BTN',
  categoryFilterBtn: 'TRANSACTION_ALL_CATEGORY_FILTRE_BTN',
  methodFilterBtn: 'TRANSACTION_ALL_METHOD_FILTRE_BTN',
  statusFilterBtn: 'TRANSACTION_ALL_STATUS_FILTRE_BTN'
};

export const transactionInOutDataQa = {
  page: 'TRANSACTION_IN_OUT_PAGE',
  title: 'TRANSACTION_IN_OUT_TITLE',
  sendPaymentToAnotherWalletBtn: 'TRANSACTION_IN_OUT_SEND_PAYMENT_TO_ANOTHER_WALLET_BTN',
  simulateMoneyInBtn: 'TRANSACTION_ALL_SIMULATE_MONEY_IN_BTN',
  dateSelector: 'TRANSACTION_IN_OUT_DATE_SELECTOR',
  searchBar: 'TRANSACTION_IN_OUT_SEARCH_BAR',
  refreshBtn: 'TRANSACTION_IN_OUT_REFRESH_BTN',
  exportBtn: 'TRANSACTION_IN_OUT_EXPORT_BTN',
  defaultDataBtn: 'TRANSACTION_IN_OUT_DEFAULT_DATA_BTN',
  columnChooserBtn: 'TRANSACTION_IN_OUT_COLUMN_CHOOSER_BTN',
  id: 'TRANSACTION_IN_OUT_TRANSACTION_ID',
  idFilterBtn: 'TRANSACTION_IN_OUT_ID_FILTRE_BTN',
  typeFilterBtn: 'TRANSACTION_IN_OUT_TYPE_FILTRE_BTN',
  categoryFilterBtn: 'TRANSACTION_IN_OUT_CATEGORY_FILTRE_BTN',
  methodFilterBtn: 'TRANSACTION_IN_OUT_METHOD_FILTRE_BTN',
  statusFilterBtn: 'TRANSACTION_IN_OUT_STATUS_FILTRE_BTN',
  threeDsModeRequestedFilterBtn: 'TRANSACTION_IN_OUT_3DS_MODE_REQUESTED_FILTRE_BTN',
  threeDsResultsFilterBtn: 'TRANSACTION_IN_OUT_3DS_RESULTS_FILTRE_BTN'
};

export const transactionP2PDataQa = {
  page: 'TRANSACTION_P2P_PAGE',
  title: 'TRANSACTION_P2P_TITLE',
  sendPaymentToAnotherWalletBtn: 'TRANSACTION_P2P_SEND_PAYMENT_TO_ANOTHER_ACCOUNT_BTN',
  simulateMoneyInBtn: 'TRANSACTION_ALL_SIMULATE_MONEY_IN_BTN',
  dateSelector: 'TRANSACTION_P2P_DATE_SELECTOR',
  searchBar: 'TRANSACTION_P2P_SEARCH_BAR',
  refreshBtn: 'TRANSACTION_P2P_REFRESH_BTN',
  exportBtn: 'TRANSACTION_P2P_EXPORT_BTN',
  defaultDataBtn: 'TRANSACTION_P2P_DEFAULT_DATA_BTN',
  columnChooserBtn: 'TRANSACTION_P2P_COLUMN_CHOOSER_BTN',
  id: 'TRANSACTION_P2P_TRANSACTION_ID',
  idFilterBtn: 'TRANSACTION_P2P_ID_FILTRE_BTN',
  categoryFilterBtn: 'TRANSACTION_P2P_CATEGORY_FILTRE_BTN',
  methodFilterBtn: 'TRANSACTION_P2P_METHOD_FILTRE_BTN',
  statusFilterBtn: 'TRANSACTION_P2P_STATUS_FILTRE_BTN'
};

export const myWalletOngletsDataQa = {
  overviewPage: 'OVERVIEW_PAGE',
  title: 'MY_WALLET_TITLE',
  balanceTxt: 'MY_WALLET_BALANCE_TXT',
  overviewOnglet: 'OVERVIEW_ONGLET',
  transactionsOnglet: 'TRANSACTIONS_ONGLET',
  bankAccountsOnglet: 'BANK_ACCOUNTS_ONGLET',
  invoicesOnglet: 'INVOICES_ONGLET',
  walletStatementOnglet: 'WALLET_STATEMENT_ONGLET',
  commissionFeesOnglet: 'COMMISSION_FEES_ONGLET',
  thresholdsOnglet: 'THRESHOLDS_ONGLET',
  logsOnglet: 'LOGS_ONGLET'
};

export const myWalletOverviewTransactionSummaryDataQa = {
  title: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_TITLE',
  viewAllTransactionBtn: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_VIEW_ALL_TRANSACTION_BTN',
  todayBtn: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_TODAY_BTN',
  last7DaysBtn: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_LAST_7_DAYS_BTN',
  thisMonthBtn: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_THIS_MONTH_BTN',
  thisYearBtn: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_THIS_YEAR_BTN',
  allTimeBtn: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_ALL_TIME_BTN',
  moneyInTxt: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_MONEY_IN_TXT',
  moneyInCount: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_MONEY_IN_COUNT',
  moneyInAmount: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_MONEY_IN_AMOUNT',
  p2pReceivedTxt: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_P2P_RECEIVED_TXT',
  p2pReceivedCount: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_P2P_RECEIVED_COUNT',
  p2pReceivedAmount: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_P2P_RECEIVED_AMOUNT',
  moneyOutTxt: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_MONEY_OUT_TXT',
  moneyOutCount: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_MONEY_OUT_COUNT',
  moneyOutAmount: 'OVERVIEW_TRANSACTION_SUMMARY_MONEY_OUT_AMOUNT',
  p2pSentTxt: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_P2P_SENT_TXT',
  p2pSentCount: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_P2P_SENT_COUNT',
  p2pSentAmount: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_P2P_SENT_AMOUNT',
  chargebackTxt: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_CHARGEBACK_TXT',
  chargebackCount: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_CHARGEBACK_COUNT',
  chargebackAmount: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_CHARGEBACK_AMOUNT',
  riskReserveTitle: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_RISK_RESERVE_TITLE',
  riskReserveBlueMsg: 'MY_WALLET_OVERVIEW_TRANSACTION_SUMMARY_RISK_RESERVE_BLUE_MSG'
};

export const myWalletTransactionDataQa = {
  page: 'MY_WALLET_TRANSACTION_PAGE',
  title: 'MY_WALLET_TRANSACTION_TITLE',
  sendPaymentToAnotherWalletBtn: 'MY_WALLET_TRANSACTION_SEND_PAYMENT_TO_ANOTHER_ACCOUNT_BTN',
  dateSelector: 'MY_WALLET_TRANSACTION_DATE_SELECTOR',
  searchBar: 'MY_WALLET_TRANSACTION_SEARCH_BAR',
  refreshBtn: 'MY_WALLET_TRANSACTION_REFRESH_BTN',
  exportBtn: 'MY_WALLET_TRANSACTION_EXPORT_BTN',
  defaultDataBtn: 'MY_WALLET_TRANSACTION_DEFAULT_DATA_BTN',
  columnChooserBtn: 'MY_WALLET_TRANSACTION_COLUMN_CHOOSER_BTN',
  id: 'MY_WALLET_TRANSACTION_TRANSACTION_ID',
  idFilterBtn: 'MY_WALLET_TRANSACTION_ID_FILTRE_BTN',
  typeFilterBtn: 'MY_WALLET_TRANSACTION_TYPE_FILTRE_BTN',
  categoryFilterBtn: 'MY_WALLET_TRANSACTION_CATEGORY_FILTRE_BTN',
  methodFilterBtn: 'MY_WALLET_TRANSACTION_METHOD_FILTRE_BTN',
  statusFilterBtn: 'MY_WALLET_TRANSACTION_STATUS_FILTRE_BTN',
  simulateAMoney: 'MY_WALLET_TRANSACTION_SIMULATE_MONEY_OUT'
};

export const myWalletBankAccountDataQa = {
  page: 'MY_WALLET_BANK_ACCOUNT_PAGE',
  title: 'MY_WALLET_BANK_ACCOUNT_TITLE',
  doAWireTransferBtn: 'MY_WALLET_BANK_ACCOUNT_DO_A_WIRE_TRANSFER_BTN',
  searchBar: 'MY_WALLET_BANK_ACCOUNT_SEARCH_BAR',
  refreshBtn: 'MY_WALLET_BANK_ACCOUNT_REFRESH_BTN',
  exportBtn: 'MY_WALLET_BANK_ACCOUNT_EXPORT_BTN',
  defaultDataBtn: 'MY_WALLET_BANK_ACCOUNT_DEFAULT_DATA_BTN',
  columnChooserBtn: 'MY_WALLET_BANK_ACCOUNT_COLUMN_CHOOSER_BTN',
  actionDoAWireTransferBtn: 'MY_WALLET_TRANSACTION_ACTION_DO_A_WIRE_TRANSFER_BTN',
  actionCancelWireTransferBtn: 'MY_WALLET_BANK_ACCOUNT_ACTION_CANCEL_WIRE_TRANSFER_BTN',
  idFilterBtn: 'MY_WALLET_BANK_ACCOUNT_ID_FILTRE_BTN',
  statusFilterBtn: 'MY_WALLET_BANK_ACCOUNT_STATUS_FILTRE_BTN',
  walletTypeFilterBtn: 'MY_WALLET_BANK_ACCOUNT_ACCOUNT_TYPE_FILTRE_BTN',
  bankCountryFilterBtn: 'MY_WALLET_TRANSACTION_BANK_COUNTRY_FILTRE_BTN'
};

export const myWalletInvoicesDataQa = {
  page: 'MY_WALLET_INVOICES_PAGE',
  title: 'MY_WALLET_INVOICES_TITLE',
  group: 'MY_WALLET_INVOICES_GROUP_BY_MONTH_YEAR_RADIO_BTN',
  searchBar: 'MY_WALLET_INVOICES_SEARCH_BAR',
  refreshBtn: 'MY_WALLET_INVOICES_REFRESH_BTN',
  exportBtn: 'MY_WALLET_INVOICES_EXPORT_BTN',
  defaultDataBtn: 'MY_WALLET_INVOICES_DEFAULT_DATA_BTN',
  columnChooserBtn: 'MY_WALLET_INVOICES_COLUMN_CHOOSER_BTN',
  view: 'MY_WALLET_INVOICES_VIEW',
  pdfDownload: 'MY_WALLET_INVOICES_PDF_DOWNLOAD',
  idFilterBtn: 'MY_WALLET_INVOICES_ID_FILTRE_BTN'
};

export const myWalletStatementDataQa = {
  page: 'MY_WALLET_ACCOUNT_STATEMENT_PAGE',
  title: 'MY_WALLET_ACCOUNT_STATEMENT_TITLE',
  downloadPdf: 'MY_WALLET_ACCOUNT_STATEMENT_DOWNLOAD_PDF',
  dateSelector: 'MY_WALLET_ACCOUNT_STATEMENT_DATE_SELECTOR_INPUT',
  dateSelectorTxt: 'MY_WALLET_ACCOUNT_STATEMENT_DATE_SELECTOR_TXT',
  walletToBeConsideredTxt: 'MY_WALLET_ACCOUNT_STATEMENT_WALLET_TO_BE_CONSIDERED_TXT',
  walletToBeConsidered: 'MY_WALLET_ACCOUNT_STATEMENT_WALLET_TO_BE_CONSIDERED_INPUT',
  balanceSummaryTitle: 'MY_WALLET_ACCOUNT_STATEMENT_BALANCE_SUMMARY_TITLE',
  startingBalanceTxt: 'MY_WALLET_ACCOUNT_STATEMENT_STARTING_BALANCE_TXT',
  startingBalanceAmount: 'MY_WALLET_ACCOUNT_STATEMENT_STARTING_BALANCE_AMOUNT',
  balanceChangeTxt: 'MY_WALLET_ACCOUNT_STATEMENT_BALANCE_CHANGE_TXT',
  balanceChangeAmount: 'MY_WALLET_ACCOUNT_STATEMENT_BALANCE_CHANGE_AMOUNT',
  endingBalanceTxt: 'MY_WALLET_ACCOUNT_STATEMENT_ENDING_BALANCE_TXT',
  endingBalanceAmount: 'MY_WALLET_ACCOUNT_STATEMENT_ENDING_BALANCE_AMOUNT',
  balanceChangeBreakdownTitle: 'MY_WALLET_ACCOUNT_STATEMENT_BALANCE_CHANGE_BREAKDOWN_TITLE',
  typeIncoming: 'MY_WALLET_ACCOUNT_STATEMENT_TYPE_INCOMING',
  categoryMoneyIn: 'MY_WALLET_ACCOUNT_STATEMENT_CATEGORY_MONEY_IN',
  categoryCreditChargeBack: 'MY_WALLET_ACCOUNT_STATEMENT_CATEGORY_CHARGE_BACK',
  incomingCount: 'MY_WALLET_ACCOUNT_STATEMENT_INCOMING_COUNT',
  incomingCredit: 'MY_WALLET_ACCOUNT_STATEMENT_INCOMING_CREDIT',
  typeOutgoing: 'MY_WALLET_ACCOUNT_STATEMENT_TYPE_OUTGOING',
  categoryMoneyOut: 'MY_WALLET_ACCOUNT_STATEMENT_CATEGORY_MONEY_OUT',
  categoryRefunds: 'MY_WALLET_ACCOUNT_STATEMENT_CATEGORY_REFUNDS',
  outgoingCount: 'MY_WALLET_ACCOUNT_STATEMENT_OUTGOING_COUNT',
  outgoingDebit: 'MY_WALLET_ACCOUNT_STATEMENT_OUTGOING_DEBIT',
  typeP2pReceived: 'MY_WALLET_ACCOUNT_STATEMENT_TYPE_P2P_RECEIVED',
  p2pReceivedCategoryTransfers: 'MY_WALLET_ACCOUNT_STATEMENT_P2P_RECEIVED_CATEGORY_TRANSFERS',
  p2pReceivedCount: 'MY_WALLET_ACCOUNT_STATEMENT_P2P_RECEIVED_COUNT',
  p2pReceivedCredit: 'MY_WALLET_ACCOUNT_STATEMENT_P2P_RECEIVED_CREDIT',
  p2pReceivedCategoryPartnerCommission:
    'MY_WALLET_ACCOUNT_STATEMENT_P2P_RECEIVED_CATEGORY_PARTNER_COMMISSION',
  p2pReceivedPartnerCommissionCount:
    'MY_WALLET_ACCOUNT_STATEMENT_P2P_RECEIVED_PARTNER_COMMISSION_COUNT',
  p2pReceivedPartnerCommissionDebit:
    'MY_WALLET_ACCOUNT_STATEMENT_P2P_RECEIVED_PARTNER_COMMISSION_DEBIT',
  typeP2pSent: 'MY_WALLET_ACCOUNT_STATEMENT_TYPE_P2P_SENT',
  p2pSentCategoryTransfers: 'MY_WALLET_ACCOUNT_STATEMENT_P2P_SENT_CATEGORY_TRANSFERS',
  p2pSentCount: 'MY_WALLET_ACCOUNT_STATEMENT_P2P_SENT_COUNT',
  p2pSentDebit: 'MY_WALLET_ACCOUNT_STATEMENT_P2P_SENT_DEBIT',
  p2pSentCategoryPartnerCommission:
    'MY_WALLET_ACCOUNT_STATEMENT_P2P_SENT_CATEGORY_PARTNER_COMMISSION',
  p2pSentPartnerCommissionCount: 'MY_WALLET_ACCOUNT_STATEMENT_P2P_SENT_PARTNER_COMMISSION_COUNT',
  p2pSentPartnerCommissionDebit: 'MY_WALLET_ACCOUNT_STATEMENT_P2P_SENT_PARTNER_COMMISSION_DEBIT',
  p2pSentCategoryLemonwayCommission:
    'MY_WALLET_ACCOUNT_STATEMENT_P2P_SENT_CATEGORY_LEMONWAY_COMMISSION',
  p2pSentLemonwayCommissionCount:
    'MY_WALLET_ACCOUNT_STATEMENT_P2P_SENT_CATEGORY_LEMONWAY_COMMISSION_COUNT',
  p2pSentLemonwayCommissionDebit:
    'MY_WALLET_ACCOUNT_STATEMENT_P2P_SENT_CATEGORY_LEMONWAY_COMMISSION_DEBIT',
  p2pSentCategoryLemonwayFees: 'MY_WALLET_ACCOUNT_STATEMENT_P2P_SENT_CATEGORY_LEMONWAY_FEES',
  p2pSentLemonwayFeesCount: 'MY_WALLET_ACCOUNT_STATEMENT_P2P_SENT_CATEGORY_LEMONWAY_FEES_COUNT',
  p2pSentLemonwayFeesDebit: 'MY_WALLET_ACCOUNT_STATEMENT_P2P_SENT_CATEGORY_LEMONWAY_FEES_DEBIT',
  total: 'MY_WALLET_ACCOUNT_STATEMENT_TOTAL',
  totalCount: 'MY_WALLET_ACCOUNT_STATEMENT_TOTAL_COUNT',
  totalCredit: 'MY_WALLET_ACCOUNT_STATEMENT_TOTAL_CREDIT'
};

export const walletStatementDataQa = {
  page: 'WALLET_ACCOUNT_STATEMENT_PAGE',
  title: 'WALLET_ACCOUNT_STATEMENT_TITLE',
  downloadPdf: 'WALLET_ACCOUNT_STATEMENT_DOWNLOAD_PDF',
  dateSelector: 'WALLET_ACCOUNT_STATEMENT_DATE_SELECTOR',
  balanceSummaryTitle: 'WALLET_ACCOUNT_STATEMENT_BALANCE_SUMMARY_TITLE',
  startingBalanceTxt: 'WALLET_ACCOUNT_STATEMENT_STARTING_BALANCE_TXT',
  startingBalanceAmount: 'WALLET_ACCOUNT_STATEMENT_STARTING_BALANCE_AMOUNT',
  balanceChangeTxt: 'WALLET_ACCOUNT_STATEMENT_BALANCE_CHANGE_TXT',
  balanceChangeAmount: 'WALLET_ACCOUNT_STATEMENT_BALANCE_CHANGE_AMOUNT',
  endingBalanceTxt: 'WALLET_ACCOUNT_STATEMENT_ENDING_BALANCE_TXT',
  endingBalanceAmount: 'WALLET_ACCOUNT_STATEMENT_ENDING_BALANCE_AMOUNT',
  balanceChangeBreakdownTitle: 'WALLET_ACCOUNT_STATEMENT_BALANCE_CHANGE_BREAKDOWN_TITLE',
  typeIncoming: 'WALLET_ACCOUNT_STATEMENT_TYPE_INCOMING',
  categoryMoneyIn: 'WALLET_ACCOUNT_STATEMENT_CATEGORY_MONEY_IN',
  incomingCount: 'WALLET_ACCOUNT_STATEMENT_INCOMING_COUNT',
  incomingCredit: 'WALLET_ACCOUNT_STATEMENT_INCOMING_CREDIT',
  typeOutgoing: 'WALLET_ACCOUNT_STATEMENT_TYPE_OUTGOING',
  categoryMoneyOut: 'WALLET_ACCOUNT_STATEMENT_CATEGORY_MONEY_OUT',
  outgoingCount: 'WALLET_ACCOUNT_STATEMENT_OUTGOING_COUNT',
  outgoingDebit: 'WALLET_ACCOUNT_STATEMENT_OUTGOING_DEBIT',
  typeP2PReceived: 'WALLET_ACCOUNT_STATEMENT_TYPE_P2P_RECEIVED',
  p2pReceivedCategoryTransfers: 'WALLET_ACCOUNT_STATEMENT_P2P_RECEIVED_CATEGORY_TRANSFERS',
  p2pReceivedCount: 'WALLET_ACCOUNT_STATEMENT_P2P_RECEIVED_COUNT',
  p2pReceivedDebit: 'WALLET_ACCOUNT_STATEMENT_P2P_RECEIVED_DEBIT',
  p2pReceivedCategoryPartnerCommission:
    'WALLET_ACCOUNT_STATEMENT_P2P_RECEIVED_CATEGORY_PARTNER_COMMISSION',
  p2pReceivedPartnerCommissionCount:
    'WALLET_ACCOUNT_STATEMENT_P2P_RECEIVED_PARTNER_COMMISSION_COUNT',
  p2pReceivedPartnerCommissionDebit:
    'WALLET_ACCOUNT_STATEMENT_P2P_RECEIVED_PARTNER_COMMISSION_DEBIT',
  typeP2PSent: 'WALLET_ACCOUNT_STATEMENT_TYPE_P2P_SENT',
  p2pSentCategoryTransfers: 'WALLET_ACCOUNT_STATEMENT_P2P_SENT_CATEGORY_TRANSFERS',
  p2pSentCount: 'WALLET_ACCOUNT_STATEMENT_P2P_SENT_COUNT',
  p2pSentDebit: 'WALLET_ACCOUNT_STATEMENT_P2P_SENT_DEBIT',
  p2pSentCategoryPartnerCommission: 'WALLET_ACCOUNT_STATEMENT_P2P_SENT_CATEGORY_PARTNER_COMMISSION',
  p2pSentPartnerCommissionCount: 'WALLET_ACCOUNT_STATEMENT_P2P_SENT_PARTNER_COMMISSION_COUNT',
  p2pSentPartnerCommissionDebit: 'WALLET_ACCOUNT_STATEMENT_P2P_SENT_PARTNER_COMMISSION_DEBIT',
  p2pSentCategoryLemonwayCommission:
    'WALLET_ACCOUNT_STATEMENT_P2P_SENT_CATEGORY_LEMONWAY_COMMISSION',
  p2pSentCategoryLemonwayCommissionCount:
    'WALLET_ACCOUNT_STATEMENT_P2P_SENT_CATEGORY_LEMONWAY_COMMISSION_COUNT',
  p2pSentCategoryLemonwayCommissionDebit:
    'WALLET_ACCOUNT_STATEMENT_P2P_SENT_CATEGORY_LEMONWAY_COMMISSION_DEBIT',
  p2pSentCategoryLemonwayFees: 'WALLET_ACCOUNT_STATEMENT_P2P_SENT_CATEGORY_LEMONWAY_FEES',
  p2pSentCategoryLemonwayFeesCount:
    'WALLET_ACCOUNT_STATEMENT_P2P_SENT_CATEGORY_LEMONWAY_FEES_COUNT',
  p2pSentCategoryLemonwayFeesDebit:
    'WALLET_ACCOUNT_STATEMENT_P2P_SENT_CATEGORY_LEMONWAY_FEES_DEBIT',
  total: 'WALLET_ACCOUNT_STATEMENT_TOTAL',
  totalCount: 'WALLET_ACCOUNT_STATEMENT_TOTAL_COUNT',
  totalCredit: 'WALLET_ACCOUNT_STATEMENT_TOTAL_CREDIT',
  balanceChangeBreakdownTable: 'WALLET_STATEMENT_BALANCE_CHANGE_BREAKDOWN',
  balanceSummaryList: 'WALLET_STATEMENT_BALANCE_SUMMARY_LIST'
};

export const myWalletCommissionsFeesDataQa = {
  page: 'MY_WALLET_COMMISSIONS_FEES_PAGE',
  title: 'MY_WALLET_COMMISSIONS_FEES_TITLE',
  searchBar: 'MY_WALLET_COMMISSIONS_FEES_SEARCH_BAR',
  refreshBtn: 'MY_WALLET_COMMISSIONS_FEES_REFRESH_BTN',
  exportBtn: 'MY_WALLET_COMMISSIONS_FEES_EXPORT_BTN',
  defaultDataBtn: 'MY_WALLET_COMMISSIONS_FEES_DEFAULT_DATA_BTN',
  columnChooserBtn: 'MY_WALLET_COMMISSIONS_FEES_COLUMN_CHOOSER_BTN',
  collectingWalletFeeLastCheckbox: 'MY_WALLET_COMMISSIONS_FEES_COLLECTING_ACCOUNT_FEE_LAST_CHECKBOX'
};

export const myWalletThresholdsDataQa = {
  page: 'MY_WALLET_THRESHOLDS_PAGE',
  title: 'MY_WALLET_THRESHOLDS_TITLE',
  downloadBtn: 'MY_WALLET_THRESHOLDS_DOWNLOAD_BTN',
  table: 'MY_WALLET_THRESHOLDS_TABLE'
};

export const myWalletLogsDataQa = {
  page: 'MY_WALLET_LOGS_PAGE',
  title: 'MY_WALLET_LOGS_TITLE',
  searchBar: 'MY_WALLET_LOGS_SEARCH_BAR',
  refreshBtn: 'MY_WALLET_LOGS_REFRESH_BTN',
  exportBtn: 'MY_WALLET_LOGS_EXPORT_BTN',
  defaultDataBtn: 'MY_WALLET_LOGS_DEFAULT_DATA_BTN',
  columnChooserBtn: 'MY_WALLET_LOGS_COLUMN_CHOOSER_BTN'
};

export const reportsDataQa = {
  page: 'REPORTS_PAGE',
  title: 'REPORTS_TITLE',
  dateSelector: 'REPORTS_DATE_SELECTOR',
  timeIntervalSelector: 'REPORTS_TIME_INTERVAL_SELECTOR',
  moneyInTitle: 'REPORTS_MONEY_IN_TITLE',
  successfulMoneyInTransactionTitle: 'REPORTS_SUCCESSFUL_MONEY_IN_TRANSACTION_TITLE',
  successfulMoneyInTransactionAmount: 'REPORTS_SUCCESSFUL_MONEY_IN_TRANSACTION_AMOUNT',
  successfulMoneyInTransactionSvg: 'REPORTS_SUCCESSFUL_MONEY_IN_TRANSACTION_SVG',
  breakdownOfSuccessfulMoneyInPerMethodTitle:
    'REPORTS_BREAKDOWN_OF_SUCCESSFUL_MONEY_IN_PER_METHOD_TITLE',
  breakdownOfSuccessfulMoneyInPerMethodSvg:
    'REPORTS_BREAKDOWN_OF_SUCCESSFUL_MONEY_IN_PER_METHOD_SVG',
  moneyOutTitle: 'REPORTS_MONEY_OUT_TITLE',
  successfulMoneyOutTransactionTitle: 'REPORTS_SUCCESSFUL_MONEY_OUT_TRANSACTION_TITLE',
  successfulMoneyOutTransactionAmount: 'REPORTS_SUCCESSFUL_MONEY_OUT_TRANSACTION_AMOUNT',
  successfulMoneyOutTransactionSvg: 'REPORTS_SUCCESSFUL_MONEY_OUT_TRANSACTION_SVG',
  commissionsTitle: 'REPORTS_COMMISSIONS_TITLE',
  partnerCommissionTitle: 'REPORTS_PARTNER_COMMISSION_TITLE',
  partnerCommissionAmount: 'REPORTS_PARTNER_COMMISSION_AMOUNT',
  partnerCommissionSvg: 'REPORTS_PARTNER_COMMISSION_SVG',
  chargebackTitle: 'REPORTS_CHARGEBACK_TITLE',
  chargebackTransactionTitle: 'REPORTS_CHARGEBACK_TRANSACTION_TITLE',
  chargebackTransactionAmount: 'REPORTS_CHARGEBACK_TRANSACTION_AMOUNT',
  chargebackTransactionSvg: 'REPORTS_CHARGEBACK_TRANSACTION_SVG',
  chargebackRateTitle: 'REPORTS_CHARGEBACK_RATE_TITLE',
  chargebackRateAmount: 'REPORTS_CHARGEBACK_RATE_AMOUNT',
  chargebackRateSvg: 'REPORTS_CHARGEBACK_RATE_SVG'
};

export const ipAddressWhitelistDataQa = {
  page: 'IP_ADDRESS_WHITELIST_PAGE',
  title: 'IP_ADDRESS_WHITELIST_TITLE',
  addAnIpAddressBtn: 'IP_ADDRESS_WHITELIST_ADD_AN_IP_ADDRESS_BTN',
  searchBar: 'IP_ADDRESS_WHITELIST_SEARCH_BAR',
  refreshBtn: 'IP_ADDRESS_WHITELIST_REFRESH_BTN',
  exportBtn: 'IP_ADDRESS_WHITELIST_EXPORT_BTN',
  defaultDataBtn: 'IP_ADDRESS_WHITELIST_DEFAULT_DATA_BTN',
  columnChooserBtn: 'IP_ADDRESS_WHITELIST_COLUMN_CHOOSER_BTN',
  applicationFilterBtn: 'IP_ADDRESS_WHITELIST_APPLICATION_FILTER_BTN',
  dateAddedFilterBtn: 'IP_ADDRESS_WHITELIST_DATE_ADDED_FILTER_BTN',
  actionDeleteBtn: 'IP_ADDRESS_WHITELIST_ACTION_DELETE_BTN'
};

export const whitelistAnIpAddressPopupDataQa = {
  popup: 'WHITELIST_AN_IP_ADDRESS_POPUP',
  apiBtn: 'WHITELIST_AN_IP_ADDRESS_API_BTN',
  dashboardBtn: 'WHITELIST_AN_IP_ADDRESS_DASHBOARD_BTN',
  ipAddressToWhitelistTxt: 'WHITELIST_AN_IP_ADDRESS_IP_ADDRESS_TO_WHITELIST_TXT',
  ipAddressToWhitelistInput: 'WHITELIST_AN_IP_ADDRESS_IP_ADDRESS_TO_WHITELIST_INPUT',
  descriptionTxt: 'WHITELIST_AN_IP_ADDRESS_DESCRIPTION_TXT',
  descriptionInput: 'WHITELIST_AN_IP_ADDRESS_DESCRIPTION_INPUT',
  confirmWithYourPasswordTxt: 'WHITELIST_AN_IP_ADDRESS_CONFIRM_WITH_YOUR_PASSWORD_TXT',
  confirmWithYourPasswordInput: 'WHITELIST_AN_IP_ADDRESS_CONFIRM_WITH_YOUR_PASSWORD_INPUT',
  confirmWithYourPasswordOeil: 'WHITELIST_AN_IP_ADDRESS_CONFIRM_WITH_YOUR_PASSWORD_OEIL',
  cancelBtn: 'WHITELIST_AN_IP_ADDRESS_CANEL_BTN',
  whitelistBtn: 'WHITELIST_AN_IP_ADDRESS_WHITELIST_BTN',
  closeIcon: 'WHITELIST_AN_IP_ADDRESS_CLOSE_ICON'
};

export const removeWhitelistAnIpAddressDataQa = {
  popup: 'REMOVE_WHITELIST_AN_IP_ADDRESS_POPUP',
  cancelBtn: 'REMOVE_WHITELIST_AN_IP_ADDRESS_CANEL_BTN',
  whitelistBtn: 'REMOVE_WHITELIST_AN_IP_ADDRESS_WHITELIST_BTN',
  msgYellow: ' REMOVE WHITELIST_AN_IP_ADDRESS_YELLOW_MSG ',
  closeIcon: 'REMOVE_WHITELIST_AN_IP_ADDRESS_CLOSE_ICON',
  confirmWithYourPasswordTxt: 'REMOVE_WHITELIST_AN_IP_ADDRESS_CONFIRM_WITH_YOUR_PASSWORD_TXT',
  confirmWithYourPasswordInput: 'REMOVE_WHITELIST_AN_IP_ADDRESS_CONFIRM_WITH_YOUR_PASSWORD_INPUT',
  confirmWithYourPasswordOeil: 'REMOVE_WHITELIST_AN_IP_ADDRESS_CONFIRM_WITH_YOUR_PASSWORD_EYE'
};

export const removeApprovalWorkflowDataQa = {
  popup: 'REMOVE_APPROVAL_WORKFLOW_POPUP',
  cancelBtn: 'REMOVE_APPROVAL_WORKFLOW_CANCEL_BTN',
  saveBtn: 'REMOVE_APPROVAL_WORKFLOW_BTN',
  msgYellow: ' REMOVE APPROVAL_WORKFLOW_YELLOW_MSG ',
  closeIcon: 'REMOVE_APPROVAL_WORKFLOW_CLOSE_ICON',
  confirmWithYourPasswordTxt: 'REMOVE_APPROVAL_WORKFLOW_CONFIRM_WITH_YOUR_PASSWORD_TXT',
  confirmWithYourPasswordInput: 'REMOVE_APPROVAL_WORKFLOW_CONFIRM_WITH_YOUR_PASSWORD_INPUT',
  confirmWithYourPasswordOeil: 'REMOVE_APPROVAL_WORKFLOW_CONFIRM_WITH_YOUR_PASSWORD_OEIL'
};

export const userUserPageDataQa = {
  page: 'USER_USER_PAGE',
  title: 'USER_USER_TITLE',
  inviteBtn: 'USER_USER_INVITE_USER_BTN',
  onglet: 'USER_USER_USER_ONGLET_BTN',
  searchBar: 'USER_USER_SEARCH_BAR',
  refreshBtn: 'USER_USER_REFRESH_BTN',
  exportBtn: 'USER_USER_EXPORT_BTN',
  defaultDataBtn: 'USER_USER_DEFAULT_DATA_BTN',
  columnChooserBtn: 'USER_USER_COLUMN_CHOOSER_BTN',
  editBtn: 'USER_USER_EDIT_BTN',
  roleLink: 'USER_USER_ROLE_LINK'
};

export const userInvitationsPageDataQa = {
  page: 'USER_INVITATIONS_PAGE',
  inviteBtn: 'USER_INVITATIONS_INVITE_USER_BTN',
  onglet: 'USER_USER_INVITATIONS_ONGLET_BTN',
  searchBar: 'USER_INVITATIONS_SEARCH_BAR',
  refreshBtn: 'USER_INVITATIONS_REFRESH_BTN',
  exportBtn: 'USER_INVITATIONS_EXPORT_BTN',
  defaultDataBtn: 'USER_INVITATIONS_DEFAULT_DATA_BTN',
  columnChooserBtn: 'USER_INVITATIONS_COLUMN_CHOOSER_BTN',
  roleLink: 'USER_INVITATIONS_LAST_ROLE_LINK',
  actionEditBtn: 'USER_INVITATIONS_ACTION_EDIT_BTN',
  actionSentBtn: 'USER_INVITATIONS_ACTION_SENT_BTN',
  actionCancelBtn: 'USER_INVITATIONS_ACTION_CANCEL_BTN'
};

export const editUserPopupDataQa = {
  popup: 'EDIT_USER_POPUP',
  title: 'EDIT_USER_TITLE',
  blueMsg: 'EDIT_USER_BLUE_MSG',
  activeUserTxt: 'EDIT_USER_ACTIVE_USER_TXT',
  activeUserRadio: 'EDIT_USER_ACTIVE_USER_RADIO',
  roleTxt: 'EDIT_USER_ROLE_TXT',
  roleSelector: 'EDIT_USER_ROLE_SELECTOR',
  cancelBtn: 'EDIT_USER_CANCEL_BTN',
  saveChangesBtn: 'EDIT_USER_SAVE_CHANGES_BTN',
  closeIcon: 'EDIT_USER_CLOSE_ICON'
};

export const inviteUserPopupDataQa = {
  popup: 'INVITE_USER_POPUP',
  title: 'INVITE_USER_TITLE',
  blueMsg: 'INVITE_USER_BLUE_MSG',
  emailTxt: 'INVITE_USER_EMAIL_TXT',
  emailInput: 'INVITE_USER_EMAIL_INPUT',
  roleTxt: 'INVITE_USER_ROLE_TXT',
  roleSelector: 'INVITE_USER_ROLE_SELECTOR',
  cancelBtn: 'INVITE_USER_CANCEL_BTN',
  sendInvitationBtn: 'INVITE_USER_SEND_INVITATION_BTN',
  closeIcon: 'INVITE_USER_CLOSE_ICON'
};

export const editInvitationPopupDataQa = {
  popup: 'EDIT_INVITATION_POPUP',
  title: 'EDIT_INVITATION_TITLE',
  roleTxt: 'EDIT_INVITATION_ROLE_TXT',
  roleSelector: 'EDIT_INVITATION_ROLE_SELECTOR',
  cancelBtn: 'EDIT_INVITATION_CANCEL_BTN',
  saveChangesBtn: 'EDIT_INVITATION_SAVE_CHANGES_BTN',
  closeIcon: 'EDIT_INVITATION_CLOSE_ICON'
};

export const cancelInvitationPopupDataQa = {
  popup: 'CANCEL_INVITATION_POPUP',
  title: 'CANCEL_INVITATION_TITLE',
  yellowMsg: 'CANCEL_INVITATION_YELLOW_MSG',
  cancelBtn: 'CANCEL_INVITATION_CANCEL_BTN',
  saveChangesBtn: 'CANCEL_INVITATION_SAVE_CHANGES_BTN',
  closeIcon: 'CANCEL_INVITATION_CLOSE_ICON'
};

export const twoFactorAuthDataQa = {
  notActivatedPage: '2FA_NOT_ACTIVATED_PAGE',
  title: '2FA_TITLE',
  notActivatedImg: '2FA_NOT_ACTIVATED_IMG',
  activateBtn: '2FA_ACTIVATE_2FA_BTN',
  activatedPage: '2FA_ACTIVATED_PAGE',
  activatedImg: '2FA_ACTIVATED_IMG',
  revokeBtn: '2FA_REVOKE_2FA_BTN'
};

export const activate2faPopupDataQa = {
  popup: 'ACTIVATE_2FA_POPUP',
  title: 'ACTIVATE_2FA_TITLE',
  blueMsg: 'ACTIVATE_2FA_QA_BLUE_MSG',
  qrCodeImg: 'ACTIVATE_2FA_CODE_QR_IMG',
  qrCodePasteBtn: 'ACTIVATE_2FA_CODE_QR_PASTE_BTN',
  verificationCodeBlueMsg: 'ACTIVATE_2FA_VERIFICATION_CODE_BLUE_MSG',
  verificationCodeInput: 'ACTIVATE_2FA_VERIFICATION_CODE_INPUT',
  cancelBtn: 'ACTIVATE_2FA_CANCEL_BTN',
  activateBtn: 'ACTIVATE_2FA_ACTIVATE_BTN',
  closeIcon: 'ACTIVATE_2FA_CLOSE_ICON'
};

export const rolesPageDataQa = {
  page: 'ROLES_PAGE',
  title: 'ROLES_TITLE',
  createNewRoleBtn: 'ROLES_CREATE_A_NEW_ROLE_BTN',
  searchBar: 'ROLES_SEARCH_BAR',
  refreshBtn: 'ROLES_REFRESH_BTN',
  exportBtn: 'ROLES_EXPORT_BTN',
  defaultDataBtn: 'ROLES_DEFAULT_DATA_BTN',
  columnChooserBtn: 'ROLES_COLUMN_CHOOSER_BTN',
  editBtn: 'ROLES_EDIT_BTN',
  duplicateBtn: 'ROLES_DUPLICATE_BTN'
};

export const createNewRolePopupDataQa = {
  popup: 'CREATE_A_NEW_ROLE_POPUP',
  title: 'CREATE_A_NEW_ROLE_TITLE',
  roleTxt: 'CREATE_A_NEW_ROLE_ROLE_TXT',
  roleSelector: 'CREATE_A_NEW_ROLE_ROLE_SELECTOR',
  cancelBtn: 'CREATE_A_NEW_ROLE_CANCEL_BTN',
  continueBtn: 'CREATE_A_NEW_ROLE_CONTINUE_BTN',
  saveBtn: 'CREATE_A_NEW_ROLE_SAVE_BTN',
  closeIcon: 'CREATE_A_NEW_ROLE_CLOSE_ICON',
  roleName: 'CREATE_A_NEW_ROLE_NAME',
  roleDescription: 'CREATE_A_NEW_ROLE_DESCRIPTION',
  permissionsSelector: 'CREATE_A_NEW_ROLE_PERMISSIONS_SELECTOR'
};

export const editRolePopupDataQa = {
  popup: 'EDIT_ROLE_POPUP',
  title: 'EDIT_ROLE_TITLE',
  blueMsg: 'CANCEL_INVITATION_BLUE_MSG',
  permissionsSelector: 'EDIT_PERMISSIONS_SELECTOR',
  cancelBtn: 'EDIT_ROLE_CANCEL_BTN',
  continueBtn: 'EDIT_ROLE_CONTINUE_BTN',
  saveBtn: 'EDIT_ROLE_SAVE_CHANGES_BTN',
  closeIcon: 'EDIT_ROLE_CLOSE_ICON',
  roleName: 'EDIT_ROLE_NAME',
  roleDescription: 'EDIT_ROLE_DESCRIPTION'
};

export const apiKeysDataQa = {
  page: 'API_KEYS_PAGE',
  title: 'API_KEYS_TITLE',
  generateApiKeyBtn: 'API_KEYS_GENERATE_API_KEY_BTN',
  actionViewApiKeyBtn: 'API_KEYS_ACTION_VIEW_API_KEY_BTN',
  copyApiKeyBtn: 'API_KEYS_COPY_API_KEY_BTN',
  actionHideApiKeyBtn: 'API_KEYS_ACTION_HIDE_API_KEY_BTN',
  actionDeleteApiKeyBtn: 'API_KEYS_ACTION_DELETE_API_KEY_BTN'
};

export const viewApiKeyPopupDataQa = {
  popup: 'VIEW_API_KEY_POPUP',
  msg: 'VIEW_API_KEY_BLUE_MSG',
  yourPasswordTxt: 'VIEW_API_KEY_YOUR_PASSWORD_TXT',
  yourPasswordInput: 'VIEW_API_KEY_YOUR_PASSWORD_INPUT',
  yourPasswordEye: 'VIEW_API_KEY_YOUR_PASSWORD_OEIL',
  cancelBtn: 'VIEW_API_KEY_CANCEL_BTN',
  whitelistBtn: 'VIEW_API_KEY_WHITELIST_BTN',
  closeIcon: 'VIEW_API_KEY_CLOSE_ICON'
};

export const revokeApiKeyPopupDataQa = {
  popup: 'REVOKE_API_KEY_POPUP',
  msg: 'REVOKE_API_KEY_YELLOW_MSG',
  yourPasswordTxt: 'REVOKE_API_KEY_YOUR_PASSWORD_TXT',
  yourPasswordInput: 'REVOKE_API_KEY_YOUR_PASSWORD_INPUT',
  yourPasswordEye: 'REVOKE_API_KEY_YOUR_PASSWORD_OEIL',
  cancelBtn: 'REVOKE_API_KEY_CANCEL_BTN',
  whitelistBtn: 'REVOKE_API_KEY_WHITELIST_BTN',
  closeIcon: 'REVOKE_API_KEY_CLOSE_ICON'
};

export const generateApiKeyPopupDataQa = {
  popup: 'GENERATE_API_KEY_POPUP',
  msg: 'GENERATE_API_KEY_YELLOW_MSG',
  yourPasswordTxt: 'GENERATE_API_KEY_YOUR_PASSWORD_TXT',
  yourPasswordInput: 'GENERATE_API_KEY_YOUR_PASSWORD_INPUT',
  yourPasswordEye: 'GENERATE_API_KEY_YOUR_PASSWORD_OEIL',
  cancelBtn: 'GENERATE_API_KEY_CANCEL_BTN',
  whitelistBtn: 'GENERATE_API_KEY_WHITELIST_BTN',
  closeIcon: 'GENERATE_API_KEY_CLOSE_ICON'
};

export const notificationsLogsPageDataQa = {
  page: 'NOTIFICATIONS_LOGS_PAGE',
  title: 'NOTIFICATIONS_TITLE',
  logsTabBtn: 'NOTIFICATIONS_LOGS_ONGLET_BTN',
  settingsTabBtn: 'NOTIFICATIONS_SETTINGS_ONGLET_BTN',
  searchBar: 'NOTIFICATIONS_LOGS_SEARCH_BAR',
  refreshBtn: 'NOTIFICATIONS_LOGS_REFRESH_BTN',
  exportBtn: 'NOTIFICATIONS_LOGS_EXPORT_BTN',
  defaultDataBtn: 'NOTIFICATIONS_LOGS_DEFAULT_DATA_BTN',
  columnChooserBtn: 'NOTIFICATIONS_LOGS_COLUMN_CHOOSER_BTN'
};

export const notificationsSettingsPage = {
  page: 'NOTIFICATIONS_SETTINGS_PAGE',
  searchBar: 'NOTIFICATIONS_SETTINGS_SEARCH_BAR',
  refreshBtn: 'NOTIFICATIONS_SETTINGS_REFRESH_BTN',
  exportBtn: 'NOTIFICATIONS_SETTINGS_EXPORT_BTN',
  defaultDataBtn: 'NOTIFICATIONS_SETTINGS_DEFAULT_DATA_BTN',
  columnChooserBtn: 'NOTIFICATIONS_SETTINGS_COLUMN_CHOOSER_BTN',
  editNotificationAction: 'NOTIFICATIONS_SETTINGS_ACTION_EDIT_NOTIFICATION'
};

export const notificationsDataQa = {
  unsentNotificationMsg: 'NOTIFICATIONS_UNSENT_NOTIFICATION_YELLOW_MSG',
  resendNotificationBtn: 'NOTIFICATIONS_RESEND_NOTIFICATION_BTN'
};

export const editNotificationPopup = {
  popup: 'EDIT_NOTIFICATION_POPUP',
  title: 'EDIT_NOTIFICATION_TITLE',
  walletStatusTxt: 'EDIT_NOTIFICATION_WALLET_STATUS_CHANGED_TXT',
  activeNotificationTxt: 'EDIT_NOTIFICATION_ACTIVE_NOTIFICATION_TXT',
  activeNotificationRadioBtn: 'EDIT_NOTIFICATION_ACTIVE_NOTIFICATION_RADIO_BTN',
  methodEmailBtn: 'EDIT_NOTIFICATION_METHOD_EMAIL_BTN',
  methodPostBtn: 'EDIT_NOTIFICATION_METHOD_POST_BTN',
  methodGetBtn: 'EDIT_NOTIFICATION_METHOD_GET_BTN',
  emailTxt: 'EDIT_NOTIFICATION_EMAIL_TXT',
  emailInput: 'EDIT_NOTIFICATION_EMAIL_INPUT',
  cancelBtn: 'EDIT_NOTIFICATION_CANCEL_BTN',
  saveBtn: 'EDIT_NOTIFICATION_SAVE_CHANGES_BTN',
  closeIcon: 'EDIT_NOTIFICATION_CLOSE_ICON'
};

export const editStatusDocumentPopup = {
  popup: 'EDIT_DOCUMENT_STATUS_POPUP',
  title: 'EDIT_DOCUMENT_STATUS_TITLE',
  status: 'EDIT_DOCUMENT_STATUS_STATUS',
  msg: 'EDIT_DOCUMENT_STATUS_YELLOW_MSG',
  infos: 'EDIT_DOCUMENT_STATUS_INFOS_TXT',
  yourPasswordTxt: 'EDIT_DOCUMENT_STATUS_YOUR_PASSWORD_TXT',
  yourPasswordInput: 'EDIT_DOCUMENT_STATUS_YOUR_PASSWORD_INPUT',
  yourPasswordEye: 'EDIT_DOCUMENT_STATUS_YOUR_PASSWORD_OEIL',
  commentTxt: 'EDIT_DOCUMENT_STATUS_COMMENT_TXT',
  commentInput: 'EDIT_DOCUMENT_STATUS_COMMENT_INPUT',
  newStatusTxt: 'EDIT_DOCUMENT_STATUS_NEW_STATUS_TXT',
  newStatusInput: 'EDIT_DOCUMENT_STATUS_NEW_STATUS_INPUT',
  cancelBtn: 'EDIT_DOCUMENT_STATUS_CANCEL_BTN',
  saveBtn: 'EDIT_DOCUMENT_STATUS_SAVE_CHANGES_BTN',
  closeIcon: 'EDIT_DOCUMENT_STATUS_CLOSE_ICON'
};

export const addDocumentPopup = {
  popup: 'ADD_DOCUMENT_POPUP',
  title: 'ADD_DOCUMENT_TITLE',
  typeTxt: 'ADD_DOCUMENT_TYPE_TXT',
  typeInput: 'ADD_DOCUMENT_TYPE_INPUT',
  uploadTitle: 'ADD_DOCUMENT_UPLOAD_DOCUMENT_TXT',
  uploadInput: 'ADD_DOCUMENT_UPLOAD_DOCUMENT_INPUT',
  cancelBtn: 'ADD_DOCUMENT_CANCEL_BTN',
  saveBtn: 'ADD_DOCUMENT_SAVE_CHANGES_BTN',
  closeIcon: 'ADD_DOCUMENT_CLOSE_ICON'
};

export const addPaymentDataQa = {
  popup: 'ADD_PAYMENT_POPUP',
  title: 'ADD_PAYMENT_TITLE',
  primaryButton: 'ADD_PAYMENT_PRIMARY_BUTTON',
  secondaryButton: 'ADD_PAYMENT_SECONDARY_BUTTON',
  formPaymentContent: 'ADD_PAYMENT_FORM_CONTENT',
  formPaymentLeftArea: 'ADD_PAYMENT_FORM_LEFT_AREA',
  sectionTitle: 'ADD_PAYMENT_SECTION_TITLE',
  msg: 'ADD_PAYMENT_ALERT_OPTIONAL_DETAILS',
  customIdInput: 'ADD_PAYMENT_CUSTOM_ID_INPUT',
  customIdTxt: 'ADD_PAYMENT_CUSTOM_ID_TXT',
  senderWalletIdInput: 'ADD_PAYMENT_SENDER_ACCOUNT_ID_INPUT',
  senderWalletIdTxt: 'ADD_PAYMENT_SENDER_ACCOUNT_ID_TXT',
  senderFirstNameInput: 'ADD_PAYMENT_SENDER_FIRST_NAME_INPUT',
  senderFirstNameTxt: 'ADD_PAYMENT_SENDER_FIRST_NAME_TXT',
  senderLastNameInput: 'ADD_PAYMENT_SENDER_LAST_NAME_INPUT',
  senderLastNameTxt: 'ADD_PAYMENT_SENDER_LAST_NAME_TXT',
  senderEmailInput: 'ADD_PAYMENT_SENDER_EMAIL_INPUT',
  senderEmailTxt: 'ADD_PAYMENT_SENDER_EMAIL_TXT',
  amountInput: 'ADD_PAYMENT_AMOUNT_INPUT',
  amountTxt: 'ADD_PAYMENT_AMOUNT_TXT',
  commissionInput: 'ADD_PAYMENT_COMMISSION_INPUT',
  commissionTxt: 'ADD_PAYMENT_COMMISSION_TXT',
  commentInput: 'ADD_PAYMENT_COMMENT_INPUT',
  commentTxt: 'ADD_PAYMENT_COMMENT_TXT',
  msgUrl: 'ADD_PAYMENT_ALERT_OPTIONAL_URLS',
  successUrlInput: 'ADD_PAYMENT_SUCCESS_URL_INPUT',
  successUrlTxt: 'ADD_PAYMENT_SUCCESS_URL_TXT',
  cancelUrlInput: 'ADD_PAYMENT_CANCEL_URL_INPUT',
  cancelUrlTxt: 'ADD_PAYMENT_CANCEL_URL_TXT',
  errorUrlInput: 'ADD_PAYMENT_ERROR_URL_INPUT',
  errorUrlTxt: 'ADD_PAYMENT_ERROR_URL_TXT',
  notifUrlInput: 'ADD_PAYMENT_NOTIFICATION_URL_INPUT',
  notifUrlTxt: 'ADD_PAYMENT_NOTIFICATION_URL_TXT',
  cssUrlInput: 'ADD_PAYMENT_CSS_URL_INPUT',
  cssUrlTxt: 'ADD_PAYMENT_CSS_URL_TXT',
  confirmPasswordTitle: 'ADD_PAYMENT_YOUR_PASSWORD_TXT',
  confirmPasswordInput: 'ADD_PAYMENT_YOUR_PASSWORD_INPUT',
  confirmWithYourPasswordOeil: 'ADD_PAYMENT_YOUR_PASSWORD_OEIL',
  paymentSuccessAlert: 'ADD_PAYMENT_SUCCESS_ALERT',
  copyLink: 'ADD_PAYMENT_COPY_LINK',
  cancelBtn: 'ADD_PAYMENT_CANCEL_BTN',
  saveBtn: 'ADD_PAYMENT_SAVE_CHANGES_BTN',
  closeIcon: 'ADD_PAYMENT_CLOSE_ICON'
};

export const addUBODataQa = {
  popup: 'ADD_UBO_POPUP',
  title: 'ADD_UBO_TITLE',
  icon: 'ADD_UBO_ICON',
  primaryButton: 'ADD_UBO_PRIMARY_BUTTON',
  secondaryButton: 'ADD_UBO_SECONDARY_BUTTON',
  closeButton: 'ADD_UBO_CLOSE_BUTTON',
  clientFirstNameInput: 'ADD_UBO_CLIENT_FIRST_NAME_INPUT',
  clientFirstNameTxt: 'ADD_UBO_CLIENT_FIRST_NAME_TXT',
  clientLastNameInput: 'ADD_UBO_CLIENT_LAST_NAME_INPUT',
  clientLastNameTxt: 'ADD_UBO_CLIENT_LAST_NAME_TXT',
  birthdateInput: 'ADD_UBO_BIRTHDATE_INPUT',
  birthdateTxt: 'ADD_UBO_BIRTHDATE_TXT',
  birthcityInput: 'ADD_UBO_BIRTHCITY_INPUT',
  birthcityTxt: 'ADD_UBO_BIRTHCITY_TXT',
  birthcountryInput: 'ADD_UBO_BIRTHCOUNTRY_INPUT',
  birthcountryTxt: 'ADD_UBO_BIRTHCOUNTRY_TXT',
  nationalityInput: 'ADD_UBO_NATIONALITY_INPUT',
  nationalityTxt: 'ADD_UBO_NATIONALITY_TXT',
  countryInput: 'ADD_UBO_COUNTRY_INPUT',
  countryTxt: 'ADD_UBO_COUNTRY_TXT',
  confirmPasswordInput: 'ADD_UBO_PASSWORD_INPUT',
  confirmPasswordTitle: 'ADD_UBO_PASSWORD_TXT',
  confirmWithYourPasswordOeil: 'ADD_UBO_YOUR_PASSWORD_OEIL',
  cancelBtn: 'ADD_UBO_CANCEL_BTN',
  saveBtn: 'ADD_UBO_SAVE_CHANGES_BTN',
  closeIcon: 'ADD_UBO_CLOSE_ICON'
};

export const addLogCommentPopupDataQa = {
  popup: 'ADD_LOG_COMMENT_POPUP',
  textAreaTxt: 'ADD_LOG_COMMENT_TEXTAREA_TXT',
  textAreaInput: 'ADD_LOG_COMMENT_TEXTAREA_INPUT',
  cancelBtn: 'ADD_LOG_COMMENT_CANCEL_BTN',
  saveBtn: 'ADD_LOG_COMMENT_SAVE_CHANGES_BTN',
  closeIcon: 'ADD_LOG_COMMENT_CLOSE_ICON'
};

export const disablePaymentFormPopup = {
  popup: 'DISABLE_PAYMENT_FORM_POPUP',
  msg: 'DISABLE_PAYMENT_FORM_ALERT_TEXT',
  paymentFormDetails: 'DISABLE_PAYMENT_FORM_DETAILS',
  cancelBtn: 'DISABLE_PAYMENT_FORM_DETAILS_CANCEL_BTN',
  saveBtn: 'DISABLE_PAYMENT_FORM_DETAILS_SAVE_CHANGES_BTN',
  closeIcon: 'DISABLE_PAYMENT_FORM_DETAILS_CLOSE_ICON'
};

export const disableSavedCardPopup = {
  popup: 'DISABLE_SAVED_CARD_POPUP',
  msg: 'DISABLE_SAVED_CARD_ALERT_TEXT',
  details: 'DISABLE_SAVED_CARD_DETAILS',
  cancelBtn: 'DISABLE_SAVED_CARD_DETAILS_CANCEL_BTN',
  saveBtn: 'DISABLE_SAVED_CARD_DETAILS_SAVE_CHANGES_BTN',
  closeIcon: 'DISABLE_SAVED_CARD_DETAILS_CLOSE_ICON'
};

export const disableVirtualIbanPopup = {
  popup: 'DISABLE_VIRTUAL_IBAN_POPUP',
  msg: 'DISABLE_VIRTUAL_IBAN_ALERT_TEXT',
  details: 'DISABLE_VIRTUAL_IBAN_DETAILS',
  cancelBtn: 'DISABLE_VIRTUAL_IBAN_CANCEL_BTN',
  saveBtn: 'DISABLE_VIRTUAL_IBAN_SAVE_CHANGES_BTN',
  closeIcon: 'DISABLE_VIRTUAL_IBAN_CLOSE_ICON'
};

export const disableSddMandatePopup = {
  popup: 'DISABLE_SSD_MANDATE_POPUP',
  msg: 'DISABLE_SSD_MANDATE_ALERT_TEXT',
  details: 'DISABLE_SSD_MANDATE_DETAILS',
  cancelBtn: 'DISABLE_SSD_MANDATE_CANCEL_BTN',
  saveBtn: 'DISABLE_SSD_MANDATE_SAVE_CHANGES_BTN',
  closeIcon: 'DISABLE_SSD_MANDATE_CLOSE_ICON'
};

export const enableSddMandatePopup = {
  popup: 'ENABLED_SSD_MANDATE_POPUP',
  msg: 'ENABLED_SSD_MANDATE_ALERT_TEXT',
  details: 'ENABLED_SSD_MANDATE_DETAILS',
  cancelBtn: 'ENABLED_SSD_MANDATE_CANCEL_BTN',
  saveBtn: 'ENABLED_SSD_MANDATE_SAVE_CHANGES_BTN',
  closeIcon: 'ENABLED_SSD_MANDATE_CLOSE_ICON'
};

export const editWalletStatusPopupDataQa = {
  popup: 'EDIT_WALLET_STATUS_POPUP',
  msg: 'EDIT_WALLET_STATUS_ALERT_TEXT',
  details: 'EDIT_WALLET_STATUS_DETAILS',
  userEntity: 'EDIT_WALLET_STATUS_USER_ENTITY',
  status: 'EDIT_WALLET_STATUS_CHIP_STATUS',
  newStatusTxt: 'EDIT_WALLET_STATUS_NEW_STATUS_TXT',
  newStatusInput: 'EDIT_WALLET_STATUS_NEW_STATUS_INPUT',
  confirmPasswordInput: 'EDIT_WALLET_STATUS_PASSWORD_INPUT',
  confirmPasswordTitle: 'EDIT_WALLET_STATUS_PASSWORD_TXT',
  confirmWithYourPasswordOeil: 'EDIT_WALLET_STATUS_YOUR_PASSWORD_OEIL',
  cancelBtn: 'EDIT_WALLET_STATUS_CANCEL_BTN',
  saveBtn: 'EDIT_WALLET_STATUS_SAVE_CHANGES_BTN',
  closeIcon: 'EDIT_WALLET_STATUS_CLOSE_ICON'
};

export const editBankAccountStatusPopup = {
  popup: 'EDIT_BANK_ACCOUNT_STATUS_POPUP',
  msg: 'EDIT_BANK_ACCOUNT_STATUS_ALERT_TEXT',
  details: 'EDIT_BANK_ACCOUNT_STATUS_DETAILS',
  status: 'EDIT_BANK_ACCOUNT_STATUS_CHIP_CELL',
  newStatusTxt: 'EDIT_BANK_ACCOUNT_STATUS_NEW_STATUS_TXT',
  newStatusInput: 'EDIT_BANK_ACCOUNT_STATUS_NEW_STATUS_INPUT',
  confirmPasswordInput: 'EDIT_BANK_ACCOUNT_STATUS_PASSWORD_INPUT',
  confirmPasswordTitle: 'EDIT_BANK_ACCOUNT_STATUS_PASSWORD_TXT',
  confirmWithYourPasswordOeil: 'EDIT_BANK_ACCOUNT_STATUS_YOUR_PASSWORD_OEIL',
  cancelBtn: 'EDIT_BANK_ACCOUNT_STATUS_CANCEL_BTN',
  saveBtn: 'EDIT_BANK_ACCOUNT_STATUS_SAVE_CHANGES_BTN',
  closeIcon: 'EDIT_BANK_ACCOUNT_STATUS_CLOSE_ICON'
};

export const requestDebitQa = {
  popup: 'REQUEST_DEBIT_MODAL',
  sddMandateTxt: 'REQUEST_DEBIT_SDD_MANDATE_TXT',
  sddMandateInput: 'REQUEST_DEBIT_SDD_MANDATE_INPUT',
  datePicker: 'REQUEST_DEBIT_DATE_PICKER',
  datePickerTxt: 'REQUEST_DEBIT_DATE_PICKER_TXT',
  amountTxt: 'REQUEST_DEBIT_AMOUNT_TXT',
  amountInput: 'REQUEST_DEBIT_AMOUNT_INPUT',
  commissionInput: 'REQUEST_DEBIT_COMMISSION_INPUT',
  commissionTxt: 'REQUEST_DEBIT_COMMISSION_TXT',
  autoCommissionTxt: 'REQUEST_DEBIT_AUTO_COMMISSION_TXT',
  autoCommissionInput: 'REQUEST_DEBIT_AUTO_COMMISSION_INPUT',
  commentTxt: 'REQUEST_DEBIT_COMMENT_TXT',
  commentInput: 'REQUEST_DEBIT_COMMENT_INPUT',
  confirmPasswordInput: 'REQUEST_DEBIT_PASSWORD_INPUT',
  confirmPasswordTitle: 'REQUEST_DEBIT_PASSWORD_TXT',
  confirmWithYourPasswordOeil: 'REQUEST_DEBIT_YOUR_PASSWORD_OEIL',
  cancelBtn: 'REQUEST_DEBIT_CANCEL_BTN',
  saveBtn: 'REQUEST_DEBIT_SAVE_CHANGES_BTN',
  closeIcon: 'REQUEST_DEBIT_CLOSE_ICON'
};

export const viewPaymentFormQa = {
  popup: 'VIEW_PAYMENT_FORM_MODAL',
  msg: 'VIEW_PAYMENT_FORM_ALERT_TXT',
  textCopy: 'VIEW_PAYMENT_FORM_TEXT_COPY',
  cancelBtn: 'VIEW_PAYMENT_FORM_CANCEL_BTN',
  saveBtn: 'VIEW_PAYMENT_FORM_SAVE_CHANGES_BTN',
  closeIcon: 'VIEW_PAYMENT_FORM_CLOSE_ICON'
};

export const approvalWorkflowPageDataQa = {
  createNewApprovalWorkflowBtn: 'APPROVAL_WORKFLOW_CREATE_BTN'
};

export const createNewApprovalWorkflowDataQa = {
  popup: 'CREATE_A_NEW_APPROVAL_WORKFLOW_POPUP',
  title: 'CREATE_A_NEW_APPROVAL_WORKFLOW_TITLE',
  actionSelector: 'CREATE_A_NEW_APPROVAL_WORKFLOW_ACTION_SELECTOR',
  validatorsSelector: 'CREATE_A_NEW_APPROVAL_WORKFLOW_VALIDATORS_SELECTOR',
  cancelBtn: 'CREATE_A_NEW_APPROVAL_WORKFLOW_CANCEL_BTN',
  saveBtn: 'CREATE_A_NEW_APPROVAL_WORKFLOW_SAVE_BTN',
  closeIcon: 'CREATE_A_NEW_APPROVAL_WORKFLOW_CLOSE_ICON'
};

export const showApiKeyDataQa = {
  popup: 'SHOW_API_KEY_POPUP',
  cancelBtn: 'SHOW_API_KEY_CANCEL_BTN',
  confirmButton: 'SHOW_API_KEY_CONFIRM_BUTTON',
  msgYellow: ' SHOW_API_KEY_YELLOW_MSG ',
  closeIcon: 'SHOW_API_KEY_CLOSE_ICON',
  confirmWithYourPasswordTxt: 'SHOW_API_KEY_CONFIRM_WITH_YOUR_PASSWORD_TXT',
  confirmWithYourPasswordInput: 'SHOW_API_KEY_CONFIRM_WITH_YOUR_PASSWORD_INPUT',
  confirmWithYourPasswordOeil: 'SHOW_API_KEY_CONFIRM_WITH_YOUR_PASSWORD_EYE'
};
